module.exports = [
  {
    ownerName: "Brunhilde Filinkov",
    recordType: "Property",
    taxYear: 2020,
    account: 1373827,
    paid: true,
    amount: 231.22,
  },
  {
    ownerName: "Colby Bachman",
    recordType: "Property",
    taxYear: 2020,
    account: 1693800,
    paid: true,
    amount: 384.13,
  },
  {
    ownerName: "Nadine MacCathay",
    recordType: "Property",
    taxYear: 2020,
    account: 1844056,
    paid: false,
    amount: 201.44,
  },
  {
    ownerName: "Jennine Shackle",
    recordType: "Property",
    taxYear: 2020,
    account: 1880715,
    paid: true,
    amount: 2.08,
  },
  {
    ownerName: "Ricca Puttick",
    recordType: "Property",
    taxYear: 2020,
    account: 1753166,
    paid: false,
    amount: 224.96,
  },
  {
    ownerName: "Weider Shires",
    recordType: "Property",
    taxYear: 2020,
    account: 1208190,
    paid: false,
    amount: 128.83,
  },
  {
    ownerName: "Lilas Matzel",
    recordType: "Property",
    taxYear: 2020,
    account: 1538234,
    paid: false,
    amount: 451.07,
  },
  {
    ownerName: "Minta Hallyburton",
    recordType: "Property",
    taxYear: 2020,
    account: 1477060,
    paid: false,
    amount: 142.45,
  },
  {
    ownerName: "Joby Cantos",
    recordType: "Property",
    taxYear: 2020,
    account: 1499629,
    paid: false,
    amount: 240.08,
  },
  {
    ownerName: "Woody Blance",
    recordType: "Property",
    taxYear: 2020,
    account: 1987179,
    paid: false,
    amount: 489.99,
  },
  {
    ownerName: "Kurt Januszkiewicz",
    recordType: "Property",
    taxYear: 2020,
    account: 1881807,
    paid: true,
    amount: 141.19,
  },
  {
    ownerName: "Gizela Carnie",
    recordType: "Property",
    taxYear: 2020,
    account: 1452371,
    paid: false,
    amount: 462.71,
  },
  {
    ownerName: "Fredra O'Downe",
    recordType: "Property",
    taxYear: 2020,
    account: 1858399,
    paid: false,
    amount: 282.94,
  },
  {
    ownerName: "Ardis Chard",
    recordType: "Property",
    taxYear: 2020,
    account: 1980240,
    paid: true,
    amount: 279.47,
  },
  {
    ownerName: "Dane See",
    recordType: "Property",
    taxYear: 2020,
    account: 1845115,
    paid: false,
    amount: 214.65,
  },
  {
    ownerName: "Brittany Overington",
    recordType: "Property",
    taxYear: 2020,
    account: 1954711,
    paid: false,
    amount: 138.21,
  },
  {
    ownerName: "Grange Morison",
    recordType: "Property",
    taxYear: 2020,
    account: 1813123,
    paid: false,
    amount: 69.63,
  },
  {
    ownerName: "Elga McConway",
    recordType: "Property",
    taxYear: 2020,
    account: 1960918,
    paid: false,
    amount: 354.63,
  },
  {
    ownerName: "Lishe Cajkler",
    recordType: "Property",
    taxYear: 2020,
    account: 1698639,
    paid: true,
    amount: 334.46,
  },
  {
    ownerName: "Sally Chason",
    recordType: "Property",
    taxYear: 2020,
    account: 1324511,
    paid: true,
    amount: 404.46,
  },
  {
    ownerName: "Cirstoforo Cornhill",
    recordType: "Property",
    taxYear: 2020,
    account: 1746073,
    paid: false,
    amount: 8.4,
  },
  {
    ownerName: "Leonardo Broxap",
    recordType: "Property",
    taxYear: 2020,
    account: 1389406,
    paid: false,
    amount: 463.09,
  },
  {
    ownerName: "Lind Crabtree",
    recordType: "Property",
    taxYear: 2020,
    account: 1278279,
    paid: false,
    amount: 21.57,
  },
  {
    ownerName: "Courtney Clinning",
    recordType: "Property",
    taxYear: 2020,
    account: 1383202,
    paid: true,
    amount: 476.99,
  },
  {
    ownerName: "Tome Toderi",
    recordType: "Property",
    taxYear: 2020,
    account: 1852625,
    paid: false,
    amount: 327.12,
  },
  {
    ownerName: "Zacharia Mitten",
    recordType: "Property",
    taxYear: 2020,
    account: 1389963,
    paid: false,
    amount: 197.93,
  },
  {
    ownerName: "Johnny Adnett",
    recordType: "Property",
    taxYear: 2020,
    account: 1256512,
    paid: true,
    amount: 494.97,
  },
  {
    ownerName: "Mersey Rosita",
    recordType: "Property",
    taxYear: 2020,
    account: 1489707,
    paid: false,
    amount: 283.56,
  },
  {
    ownerName: "Herb Carlill",
    recordType: "Property",
    taxYear: 2020,
    account: 1427727,
    paid: true,
    amount: 167.48,
  },
  {
    ownerName: "Sharai Abbate",
    recordType: "Property",
    taxYear: 2020,
    account: 1805462,
    paid: false,
    amount: 170.54,
  },
  {
    ownerName: "Agatha Durnian",
    recordType: "Property",
    taxYear: 2020,
    account: 1201396,
    paid: true,
    amount: 253.22,
  },
  {
    ownerName: "Stepha Andreacci",
    recordType: "Property",
    taxYear: 2020,
    account: 1785676,
    paid: true,
    amount: 209.46,
  },
  {
    ownerName: "Lutero Hassen",
    recordType: "Property",
    taxYear: 2020,
    account: 1355186,
    paid: false,
    amount: 172.46,
  },
  {
    ownerName: "Kiele Suggey",
    recordType: "Property",
    taxYear: 2020,
    account: 1419579,
    paid: true,
    amount: 434.9,
  },
  {
    ownerName: "Beckie Nussey",
    recordType: "Property",
    taxYear: 2020,
    account: 1336311,
    paid: false,
    amount: 212.84,
  },
  {
    ownerName: "Haleigh Vannar",
    recordType: "Property",
    taxYear: 2020,
    account: 1895956,
    paid: true,
    amount: 438.15,
  },
  {
    ownerName: "Alison Butterfill",
    recordType: "Property",
    taxYear: 2020,
    account: 1232571,
    paid: false,
    amount: 213.89,
  },
  {
    ownerName: "Brina Choudhury",
    recordType: "Property",
    taxYear: 2020,
    account: 1650598,
    paid: true,
    amount: 88.84,
  },
  {
    ownerName: "Celestyna Goodacre",
    recordType: "Property",
    taxYear: 2020,
    account: 1393266,
    paid: false,
    amount: 277.82,
  },
  {
    ownerName: "Franky Eland",
    recordType: "Property",
    taxYear: 2020,
    account: 1755511,
    paid: true,
    amount: 443.44,
  },
  {
    ownerName: "Pippo Kiebes",
    recordType: "Property",
    taxYear: 2020,
    account: 1846547,
    paid: true,
    amount: 304.99,
  },
  {
    ownerName: "Kimberlee St Clair",
    recordType: "Property",
    taxYear: 2020,
    account: 1597468,
    paid: false,
    amount: 229.76,
  },
  {
    ownerName: "Teddie Congreve",
    recordType: "Property",
    taxYear: 2020,
    account: 1633615,
    paid: false,
    amount: 169.93,
  },
  {
    ownerName: "Dreddy Kalkofer",
    recordType: "Property",
    taxYear: 2020,
    account: 1797414,
    paid: false,
    amount: 234.62,
  },
  {
    ownerName: "Randy Dubble",
    recordType: "Property",
    taxYear: 2020,
    account: 1899984,
    paid: true,
    amount: 62.37,
  },
  {
    ownerName: "Cherise Jorge",
    recordType: "Property",
    taxYear: 2020,
    account: 1513288,
    paid: true,
    amount: 408.93,
  },
  {
    ownerName: "Randal Frail",
    recordType: "Property",
    taxYear: 2020,
    account: 1991184,
    paid: false,
    amount: 324.08,
  },
  {
    ownerName: "Jarrett Breede",
    recordType: "Property",
    taxYear: 2020,
    account: 1597213,
    paid: false,
    amount: 326.86,
  },
  {
    ownerName: "Carolann Morsley",
    recordType: "Property",
    taxYear: 2020,
    account: 1586610,
    paid: false,
    amount: 244.26,
  },
  {
    ownerName: "Janine Ferrario",
    recordType: "Property",
    taxYear: 2020,
    account: 1272776,
    paid: false,
    amount: 472.06,
  },
  {
    ownerName: "Angel Steffans",
    recordType: "Property",
    taxYear: 2020,
    account: 1245286,
    paid: false,
    amount: 167.37,
  },
  {
    ownerName: "Boony Eads",
    recordType: "Property",
    taxYear: 2020,
    account: 1914852,
    paid: false,
    amount: 50.81,
  },
  {
    ownerName: "Adolphus Tremayne",
    recordType: "Property",
    taxYear: 2020,
    account: 1325068,
    paid: false,
    amount: 431.83,
  },
  {
    ownerName: "Ryley Newport",
    recordType: "Property",
    taxYear: 2020,
    account: 1445032,
    paid: false,
    amount: 333.88,
  },
  {
    ownerName: "Rodge Stilliard",
    recordType: "Property",
    taxYear: 2020,
    account: 1414635,
    paid: false,
    amount: 493.04,
  },
  {
    ownerName: "Flossie Vallery",
    recordType: "Property",
    taxYear: 2020,
    account: 1862258,
    paid: false,
    amount: 215.86,
  },
  {
    ownerName: "Vanya Brehat",
    recordType: "Property",
    taxYear: 2020,
    account: 1583190,
    paid: false,
    amount: 294.26,
  },
  {
    ownerName: "Malina Jeffreys",
    recordType: "Property",
    taxYear: 2020,
    account: 1948689,
    paid: true,
    amount: 431.57,
  },
  {
    ownerName: "Clem Ingley",
    recordType: "Property",
    taxYear: 2020,
    account: 1353221,
    paid: true,
    amount: 496.12,
  },
  {
    ownerName: "Warden Driffill",
    recordType: "Property",
    taxYear: 2020,
    account: 1290820,
    paid: false,
    amount: 104.75,
  },
  {
    ownerName: "Emelita Hadwen",
    recordType: "Property",
    taxYear: 2020,
    account: 1496825,
    paid: false,
    amount: 391.29,
  },
  {
    ownerName: "Hagan Sancias",
    recordType: "Property",
    taxYear: 2020,
    account: 1349281,
    paid: false,
    amount: 249.13,
  },
  {
    ownerName: "Gretel Pablo",
    recordType: "Property",
    taxYear: 2020,
    account: 1352035,
    paid: true,
    amount: 29.49,
  },
  {
    ownerName: "Lilli Diess",
    recordType: "Property",
    taxYear: 2020,
    account: 1278351,
    paid: true,
    amount: 451.17,
  },
  {
    ownerName: "Ferrell Bowering",
    recordType: "Property",
    taxYear: 2020,
    account: 1552038,
    paid: false,
    amount: 352.53,
  },
  {
    ownerName: "Anselma Cayley",
    recordType: "Property",
    taxYear: 2020,
    account: 1371903,
    paid: false,
    amount: 224.51,
  },
  {
    ownerName: "Merridie Haythorn",
    recordType: "Property",
    taxYear: 2020,
    account: 1499584,
    paid: true,
    amount: 136.11,
  },
  {
    ownerName: "Giselle Burvill",
    recordType: "Property",
    taxYear: 2020,
    account: 1232783,
    paid: false,
    amount: 478.15,
  },
  {
    ownerName: "Charlean McGlynn",
    recordType: "Property",
    taxYear: 2020,
    account: 1831131,
    paid: false,
    amount: 422.75,
  },
  {
    ownerName: "Toddy Loudiane",
    recordType: "Property",
    taxYear: 2020,
    account: 1496402,
    paid: true,
    amount: 496.09,
  },
  {
    ownerName: "Angie Abramovici",
    recordType: "Property",
    taxYear: 2020,
    account: 1265062,
    paid: true,
    amount: 227.65,
  },
  {
    ownerName: "Fabiano Devonside",
    recordType: "Property",
    taxYear: 2020,
    account: 1213971,
    paid: false,
    amount: 247.6,
  },
  {
    ownerName: "Othella Balchen",
    recordType: "Property",
    taxYear: 2020,
    account: 1990183,
    paid: true,
    amount: 78.55,
  },
  {
    ownerName: "Molli Coltherd",
    recordType: "Property",
    taxYear: 2020,
    account: 1442805,
    paid: true,
    amount: 189.82,
  },
  {
    ownerName: "Tonnie Belitz",
    recordType: "Property",
    taxYear: 2020,
    account: 1331649,
    paid: true,
    amount: 251.62,
  },
  {
    ownerName: "Sadye Monaghan",
    recordType: "Property",
    taxYear: 2020,
    account: 1593870,
    paid: false,
    amount: 438.35,
  },
  {
    ownerName: "Portia Grzeszczak",
    recordType: "Property",
    taxYear: 2020,
    account: 1440627,
    paid: false,
    amount: 447.4,
  },
  {
    ownerName: "Kristin Jaher",
    recordType: "Property",
    taxYear: 2020,
    account: 1467935,
    paid: false,
    amount: 120.59,
  },
  {
    ownerName: "Mirilla Govett",
    recordType: "Property",
    taxYear: 2020,
    account: 1978159,
    paid: false,
    amount: 219.46,
  },
  {
    ownerName: "Cordie Giannini",
    recordType: "Property",
    taxYear: 2020,
    account: 1638041,
    paid: false,
    amount: 34.76,
  },
  {
    ownerName: "Gray Whittlesey",
    recordType: "Property",
    taxYear: 2020,
    account: 1293978,
    paid: false,
    amount: 414.68,
  },
  {
    ownerName: "Warden Biasi",
    recordType: "Property",
    taxYear: 2020,
    account: 1643107,
    paid: false,
    amount: 435.63,
  },
  {
    ownerName: "Kaleb Paulino",
    recordType: "Property",
    taxYear: 2020,
    account: 1239066,
    paid: false,
    amount: 314.01,
  },
  {
    ownerName: "Heloise Lucius",
    recordType: "Property",
    taxYear: 2020,
    account: 1497507,
    paid: true,
    amount: 324.12,
  },
  {
    ownerName: "Husain Mothersdale",
    recordType: "Property",
    taxYear: 2020,
    account: 1239351,
    paid: true,
    amount: 83.58,
  },
  {
    ownerName: "Kelby Schwandermann",
    recordType: "Property",
    taxYear: 2020,
    account: 1918855,
    paid: true,
    amount: 194.06,
  },
  {
    ownerName: "Giovanni Olensby",
    recordType: "Property",
    taxYear: 2020,
    account: 1580206,
    paid: true,
    amount: 4.38,
  },
  {
    ownerName: "Stace Stanford",
    recordType: "Property",
    taxYear: 2020,
    account: 1428053,
    paid: true,
    amount: 182.6,
  },
  {
    ownerName: "Augustine Mc Caughen",
    recordType: "Property",
    taxYear: 2020,
    account: 1656674,
    paid: false,
    amount: 437.04,
  },
  {
    ownerName: "Addia Lofthouse",
    recordType: "Property",
    taxYear: 2020,
    account: 1756933,
    paid: false,
    amount: 322.79,
  },
  {
    ownerName: "Cammi Jiruch",
    recordType: "Property",
    taxYear: 2020,
    account: 1720270,
    paid: true,
    amount: 129.63,
  },
  {
    ownerName: "Gustie Boughey",
    recordType: "Property",
    taxYear: 2020,
    account: 1989485,
    paid: false,
    amount: 406.05,
  },
  {
    ownerName: "Krystyna Cone",
    recordType: "Property",
    taxYear: 2020,
    account: 1494332,
    paid: false,
    amount: 131.12,
  },
  {
    ownerName: "Ruggiero Torresi",
    recordType: "Property",
    taxYear: 2020,
    account: 1788788,
    paid: true,
    amount: 456.8,
  },
  {
    ownerName: "Chauncey Kubatsch",
    recordType: "Property",
    taxYear: 2020,
    account: 1616997,
    paid: false,
    amount: 71.3,
  },
  {
    ownerName: "Sanderson Pauer",
    recordType: "Property",
    taxYear: 2020,
    account: 1553676,
    paid: false,
    amount: 433.06,
  },
  {
    ownerName: "Octavius Blasli",
    recordType: "Property",
    taxYear: 2020,
    account: 1310624,
    paid: false,
    amount: 272.35,
  },
  {
    ownerName: "Zebadiah Ropartz",
    recordType: "Property",
    taxYear: 2020,
    account: 1243731,
    paid: false,
    amount: 276.07,
  },
  {
    ownerName: "Mariska O'Lynn",
    recordType: "Property",
    taxYear: 2020,
    account: 1269973,
    paid: true,
    amount: 147.95,
  },
  {
    ownerName: "Nadiya Cotta",
    recordType: "Property",
    taxYear: 2020,
    account: 1824129,
    paid: false,
    amount: 469.51,
  },
  {
    ownerName: "Doti Lang",
    recordType: "Property",
    taxYear: 2020,
    account: 1689135,
    paid: false,
    amount: 117.61,
  },
  {
    ownerName: "Bryana Passo",
    recordType: "Property",
    taxYear: 2020,
    account: 1230444,
    paid: true,
    amount: 395.41,
  },
  {
    ownerName: "Reggi Hansel",
    recordType: "Property",
    taxYear: 2020,
    account: 1600163,
    paid: true,
    amount: 152.89,
  },
  {
    ownerName: "Beulah Antoinet",
    recordType: "Property",
    taxYear: 2020,
    account: 1910128,
    paid: false,
    amount: 205.41,
  },
  {
    ownerName: "Arch Agates",
    recordType: "Property",
    taxYear: 2020,
    account: 1602102,
    paid: false,
    amount: 165.66,
  },
  {
    ownerName: "Malorie Chess",
    recordType: "Property",
    taxYear: 2020,
    account: 1987761,
    paid: false,
    amount: 285.75,
  },
  {
    ownerName: "Collen Spurret",
    recordType: "Property",
    taxYear: 2020,
    account: 1921905,
    paid: true,
    amount: 482.48,
  },
  {
    ownerName: "Enriqueta Chillingsworth",
    recordType: "Property",
    taxYear: 2020,
    account: 1901256,
    paid: false,
    amount: 290.41,
  },
  {
    ownerName: "Batsheva Giacomuzzo",
    recordType: "Property",
    taxYear: 2020,
    account: 1544567,
    paid: false,
    amount: 383.32,
  },
  {
    ownerName: "Gratiana Girardy",
    recordType: "Property",
    taxYear: 2020,
    account: 1315724,
    paid: false,
    amount: 265.48,
  },
  {
    ownerName: "Robbie Joel",
    recordType: "Property",
    taxYear: 2020,
    account: 1328961,
    paid: true,
    amount: 120.98,
  },
  {
    ownerName: "Jesse Goodison",
    recordType: "Property",
    taxYear: 2020,
    account: 1764247,
    paid: true,
    amount: 85.28,
  },
  {
    ownerName: "Zechariah Gawkes",
    recordType: "Property",
    taxYear: 2020,
    account: 1888320,
    paid: false,
    amount: 98.8,
  },
  {
    ownerName: "Zandra Vinck",
    recordType: "Property",
    taxYear: 2020,
    account: 1731654,
    paid: false,
    amount: 198.85,
  },
  {
    ownerName: "Corney Dranfield",
    recordType: "Property",
    taxYear: 2020,
    account: 1778292,
    paid: true,
    amount: 17.3,
  },
  {
    ownerName: "Abagail Obington",
    recordType: "Property",
    taxYear: 2020,
    account: 1235368,
    paid: true,
    amount: 2.9,
  },
  {
    ownerName: "Lazarus Lill",
    recordType: "Property",
    taxYear: 2020,
    account: 1329983,
    paid: true,
    amount: 353.66,
  },
  {
    ownerName: "Giacomo Rutherforth",
    recordType: "Property",
    taxYear: 2020,
    account: 1778922,
    paid: false,
    amount: 413.57,
  },
  {
    ownerName: "Trudy Donalson",
    recordType: "Property",
    taxYear: 2020,
    account: 1709134,
    paid: true,
    amount: 428.39,
  },
  {
    ownerName: "Kristoffer Duberry",
    recordType: "Property",
    taxYear: 2020,
    account: 1714019,
    paid: true,
    amount: 90.69,
  },
  {
    ownerName: "Fairleigh Fulford",
    recordType: "Property",
    taxYear: 2020,
    account: 1299306,
    paid: false,
    amount: 494.8,
  },
  {
    ownerName: "Jessie Petrus",
    recordType: "Property",
    taxYear: 2020,
    account: 1615255,
    paid: true,
    amount: 86.3,
  },
  {
    ownerName: "Chrysa McMeeking",
    recordType: "Property",
    taxYear: 2020,
    account: 1936025,
    paid: false,
    amount: 26.89,
  },
  {
    ownerName: "Aili Wraxall",
    recordType: "Property",
    taxYear: 2020,
    account: 1980751,
    paid: false,
    amount: 491.26,
  },
  {
    ownerName: "Brent Kennefick",
    recordType: "Property",
    taxYear: 2020,
    account: 1874879,
    paid: false,
    amount: 176.78,
  },
  {
    ownerName: "Dorthy Feria",
    recordType: "Property",
    taxYear: 2020,
    account: 1743104,
    paid: false,
    amount: 273.31,
  },
  {
    ownerName: "Malachi Frichley",
    recordType: "Property",
    taxYear: 2020,
    account: 1565915,
    paid: true,
    amount: 6.56,
  },
  {
    ownerName: "Phylys Stare",
    recordType: "Property",
    taxYear: 2020,
    account: 1827266,
    paid: true,
    amount: 186.24,
  },
  {
    ownerName: "Dorian Marcu",
    recordType: "Property",
    taxYear: 2020,
    account: 1574274,
    paid: true,
    amount: 167.98,
  },
  {
    ownerName: "Rowen Tonkinson",
    recordType: "Property",
    taxYear: 2020,
    account: 1632696,
    paid: false,
    amount: 302.45,
  },
  {
    ownerName: "Demetre Hankin",
    recordType: "Property",
    taxYear: 2020,
    account: 1259058,
    paid: false,
    amount: 208.03,
  },
  {
    ownerName: "Katha Nozzolinii",
    recordType: "Property",
    taxYear: 2020,
    account: 1987501,
    paid: false,
    amount: 231.44,
  },
  {
    ownerName: "Neall Gostick",
    recordType: "Property",
    taxYear: 2020,
    account: 1340592,
    paid: false,
    amount: 12.44,
  },
  {
    ownerName: "Bobbee Thundercliffe",
    recordType: "Property",
    taxYear: 2020,
    account: 1629664,
    paid: true,
    amount: 136.86,
  },
  {
    ownerName: "Marika Gosenell",
    recordType: "Property",
    taxYear: 2020,
    account: 1403900,
    paid: true,
    amount: 398.69,
  },
  {
    ownerName: "Alwyn MacLaughlin",
    recordType: "Property",
    taxYear: 2020,
    account: 1839551,
    paid: false,
    amount: 192.56,
  },
  {
    ownerName: "Helaine Sporner",
    recordType: "Property",
    taxYear: 2020,
    account: 1381389,
    paid: true,
    amount: 290.48,
  },
  {
    ownerName: "Eran Brodbin",
    recordType: "Property",
    taxYear: 2020,
    account: 1922612,
    paid: false,
    amount: 108.45,
  },
  {
    ownerName: "Rudiger Partrick",
    recordType: "Property",
    taxYear: 2020,
    account: 1489251,
    paid: true,
    amount: 497.28,
  },
  {
    ownerName: "Pattin Beardsley",
    recordType: "Property",
    taxYear: 2020,
    account: 1755808,
    paid: false,
    amount: 45.5,
  },
  {
    ownerName: "Lemmie Shemmans",
    recordType: "Property",
    taxYear: 2020,
    account: 1213974,
    paid: false,
    amount: 180.72,
  },
  {
    ownerName: "Marcia Bouch",
    recordType: "Property",
    taxYear: 2020,
    account: 1494004,
    paid: true,
    amount: 330.2,
  },
  {
    ownerName: "Ivan Fewtrell",
    recordType: "Property",
    taxYear: 2020,
    account: 1309735,
    paid: true,
    amount: 201.92,
  },
  {
    ownerName: "Lindie Pound",
    recordType: "Property",
    taxYear: 2020,
    account: 1276403,
    paid: true,
    amount: 125.68,
  },
  {
    ownerName: "Spike Argyle",
    recordType: "Property",
    taxYear: 2020,
    account: 1628189,
    paid: true,
    amount: 494.49,
  },
  {
    ownerName: "Rurik Maddin",
    recordType: "Property",
    taxYear: 2020,
    account: 1462617,
    paid: true,
    amount: 333.24,
  },
  {
    ownerName: "Ty Hunnaball",
    recordType: "Property",
    taxYear: 2020,
    account: 1249348,
    paid: true,
    amount: 409.73,
  },
  {
    ownerName: "Judi Whelband",
    recordType: "Property",
    taxYear: 2020,
    account: 1715702,
    paid: true,
    amount: 330.82,
  },
  {
    ownerName: "Kayne Whitley",
    recordType: "Property",
    taxYear: 2020,
    account: 1489822,
    paid: true,
    amount: 133.63,
  },
  {
    ownerName: "Pat Treherne",
    recordType: "Property",
    taxYear: 2020,
    account: 1608890,
    paid: false,
    amount: 230.32,
  },
  {
    ownerName: "Waylen Maccrea",
    recordType: "Property",
    taxYear: 2020,
    account: 1292126,
    paid: true,
    amount: 141.27,
  },
  {
    ownerName: "Rad Djorevic",
    recordType: "Property",
    taxYear: 2020,
    account: 1480209,
    paid: true,
    amount: 217.24,
  },
  {
    ownerName: "Erminia Minerdo",
    recordType: "Property",
    taxYear: 2020,
    account: 1438696,
    paid: true,
    amount: 63.12,
  },
  {
    ownerName: "Floyd Glasser",
    recordType: "Property",
    taxYear: 2020,
    account: 1676012,
    paid: true,
    amount: 472.15,
  },
  {
    ownerName: "Fowler Halpin",
    recordType: "Property",
    taxYear: 2020,
    account: 1890669,
    paid: true,
    amount: 44.03,
  },
  {
    ownerName: "Lefty Element",
    recordType: "Property",
    taxYear: 2020,
    account: 1260288,
    paid: true,
    amount: 83.49,
  },
  {
    ownerName: "Barbe Lequeux",
    recordType: "Property",
    taxYear: 2020,
    account: 1207397,
    paid: false,
    amount: 312.53,
  },
  {
    ownerName: "Jorie Lippitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1513829,
    paid: true,
    amount: 189.12,
  },
  {
    ownerName: "Dodi Scott",
    recordType: "Property",
    taxYear: 2020,
    account: 1871164,
    paid: true,
    amount: 279.96,
  },
  {
    ownerName: "Miguelita Thorwarth",
    recordType: "Property",
    taxYear: 2020,
    account: 1486828,
    paid: false,
    amount: 95.05,
  },
  {
    ownerName: "Hester Umbers",
    recordType: "Property",
    taxYear: 2020,
    account: 1371427,
    paid: true,
    amount: 220.35,
  },
  {
    ownerName: "Pen Galliford",
    recordType: "Property",
    taxYear: 2020,
    account: 1660347,
    paid: true,
    amount: 36.97,
  },
  {
    ownerName: "Devin Brandenburg",
    recordType: "Property",
    taxYear: 2020,
    account: 1685984,
    paid: true,
    amount: 246.59,
  },
  {
    ownerName: "Reed Coping",
    recordType: "Property",
    taxYear: 2020,
    account: 1990212,
    paid: true,
    amount: 396.89,
  },
  {
    ownerName: "Carlin McCuish",
    recordType: "Property",
    taxYear: 2020,
    account: 1306449,
    paid: false,
    amount: 108.33,
  },
  {
    ownerName: "Alfred Boldero",
    recordType: "Property",
    taxYear: 2020,
    account: 1535842,
    paid: true,
    amount: 418.69,
  },
  {
    ownerName: "Gusta Hadlow",
    recordType: "Property",
    taxYear: 2020,
    account: 1850662,
    paid: true,
    amount: 301.21,
  },
  {
    ownerName: "Ellerey Chillistone",
    recordType: "Property",
    taxYear: 2020,
    account: 1856321,
    paid: true,
    amount: 306.63,
  },
  {
    ownerName: "Mitch Lillee",
    recordType: "Property",
    taxYear: 2020,
    account: 1353175,
    paid: false,
    amount: 182.58,
  },
  {
    ownerName: "Flossy McAlester",
    recordType: "Property",
    taxYear: 2020,
    account: 1599207,
    paid: true,
    amount: 300.27,
  },
  {
    ownerName: "Iseabal O'Sirin",
    recordType: "Property",
    taxYear: 2020,
    account: 1325971,
    paid: false,
    amount: 471.22,
  },
  {
    ownerName: "Merrie Matthensen",
    recordType: "Property",
    taxYear: 2020,
    account: 1649623,
    paid: false,
    amount: 169.78,
  },
  {
    ownerName: "Aleece Seckington",
    recordType: "Property",
    taxYear: 2020,
    account: 1989825,
    paid: true,
    amount: 261.85,
  },
  {
    ownerName: "Chaim Curless",
    recordType: "Property",
    taxYear: 2020,
    account: 1523697,
    paid: false,
    amount: 150.09,
  },
  {
    ownerName: "Sherwin O'Bradden",
    recordType: "Property",
    taxYear: 2020,
    account: 1572688,
    paid: true,
    amount: 19.05,
  },
  {
    ownerName: "Gustaf Clappison",
    recordType: "Property",
    taxYear: 2020,
    account: 1992165,
    paid: false,
    amount: 469.02,
  },
  {
    ownerName: "Murial Cobson",
    recordType: "Property",
    taxYear: 2020,
    account: 1969464,
    paid: false,
    amount: 119.96,
  },
  {
    ownerName: "Gaby Bruckenthal",
    recordType: "Property",
    taxYear: 2020,
    account: 1554599,
    paid: true,
    amount: 164.69,
  },
  {
    ownerName: "Aubry Kyngdon",
    recordType: "Property",
    taxYear: 2020,
    account: 1958870,
    paid: true,
    amount: 192.81,
  },
  {
    ownerName: "Rustin Stears",
    recordType: "Property",
    taxYear: 2020,
    account: 1892242,
    paid: false,
    amount: 496.94,
  },
  {
    ownerName: "Ebony Reedick",
    recordType: "Property",
    taxYear: 2020,
    account: 1734429,
    paid: false,
    amount: 456.15,
  },
  {
    ownerName: "Nathanael Gaitskell",
    recordType: "Property",
    taxYear: 2020,
    account: 1233012,
    paid: false,
    amount: 35.91,
  },
  {
    ownerName: "Marnie Fairnington",
    recordType: "Property",
    taxYear: 2020,
    account: 1445851,
    paid: false,
    amount: 182.41,
  },
  {
    ownerName: "Enid Rawes",
    recordType: "Property",
    taxYear: 2020,
    account: 1266088,
    paid: false,
    amount: 175.62,
  },
  {
    ownerName: "Luciana Guisby",
    recordType: "Property",
    taxYear: 2020,
    account: 1448950,
    paid: false,
    amount: 64.18,
  },
  {
    ownerName: "Roxanne Maher",
    recordType: "Property",
    taxYear: 2020,
    account: 1353310,
    paid: true,
    amount: 456.41,
  },
  {
    ownerName: "Ardenia Durling",
    recordType: "Property",
    taxYear: 2020,
    account: 1877665,
    paid: false,
    amount: 333.54,
  },
  {
    ownerName: "Chaddy Kennerknecht",
    recordType: "Property",
    taxYear: 2020,
    account: 1255518,
    paid: false,
    amount: 392.07,
  },
  {
    ownerName: "Carlita Drinkeld",
    recordType: "Property",
    taxYear: 2020,
    account: 1282890,
    paid: false,
    amount: 56.99,
  },
  {
    ownerName: "Lacy Brasher",
    recordType: "Property",
    taxYear: 2020,
    account: 1677192,
    paid: false,
    amount: 368.74,
  },
  {
    ownerName: "Isadora Kiossel",
    recordType: "Property",
    taxYear: 2020,
    account: 1382116,
    paid: true,
    amount: 108.51,
  },
  {
    ownerName: "Artemus Vizard",
    recordType: "Property",
    taxYear: 2020,
    account: 1456948,
    paid: false,
    amount: 284.34,
  },
  {
    ownerName: "Atlante Jacobi",
    recordType: "Property",
    taxYear: 2020,
    account: 1831456,
    paid: true,
    amount: 251.48,
  },
  {
    ownerName: "Jermain Croci",
    recordType: "Property",
    taxYear: 2020,
    account: 1331137,
    paid: true,
    amount: 464.17,
  },
  {
    ownerName: "Callean Cecil",
    recordType: "Property",
    taxYear: 2020,
    account: 1891325,
    paid: true,
    amount: 470.36,
  },
  {
    ownerName: "Linn O'Hallagan",
    recordType: "Property",
    taxYear: 2020,
    account: 1885292,
    paid: true,
    amount: 28.91,
  },
  {
    ownerName: "Junette Field",
    recordType: "Property",
    taxYear: 2020,
    account: 1322731,
    paid: true,
    amount: 417.81,
  },
  {
    ownerName: "Duane Antonin",
    recordType: "Property",
    taxYear: 2020,
    account: 1477708,
    paid: true,
    amount: 201.49,
  },
  {
    ownerName: "Allard Drillingcourt",
    recordType: "Property",
    taxYear: 2020,
    account: 1404423,
    paid: true,
    amount: 387.62,
  },
  {
    ownerName: "Marielle Struijs",
    recordType: "Property",
    taxYear: 2020,
    account: 1390449,
    paid: true,
    amount: 276.59,
  },
  {
    ownerName: "Jose Hargerie",
    recordType: "Property",
    taxYear: 2020,
    account: 1832841,
    paid: false,
    amount: 157.54,
  },
  {
    ownerName: "Marcy Kloisner",
    recordType: "Property",
    taxYear: 2020,
    account: 1320543,
    paid: false,
    amount: 362.54,
  },
  {
    ownerName: "Marylou Grossier",
    recordType: "Property",
    taxYear: 2020,
    account: 1317739,
    paid: false,
    amount: 376.79,
  },
  {
    ownerName: "Christi Poznanski",
    recordType: "Property",
    taxYear: 2020,
    account: 1487739,
    paid: false,
    amount: 478.48,
  },
  {
    ownerName: "Kipper Oldroyde",
    recordType: "Property",
    taxYear: 2020,
    account: 1237673,
    paid: false,
    amount: 129.87,
  },
  {
    ownerName: "Alwyn Langan",
    recordType: "Property",
    taxYear: 2020,
    account: 1211044,
    paid: false,
    amount: 420.57,
  },
  {
    ownerName: "Taylor Piddle",
    recordType: "Property",
    taxYear: 2020,
    account: 1356652,
    paid: true,
    amount: 381.85,
  },
  {
    ownerName: "L;urette Palay",
    recordType: "Property",
    taxYear: 2020,
    account: 1573450,
    paid: false,
    amount: 421.93,
  },
  {
    ownerName: "Xylia Bestall",
    recordType: "Property",
    taxYear: 2020,
    account: 1263677,
    paid: true,
    amount: 116.11,
  },
  {
    ownerName: "Sibel Bordone",
    recordType: "Property",
    taxYear: 2020,
    account: 1474115,
    paid: true,
    amount: 439.93,
  },
  {
    ownerName: "Octavia Aime",
    recordType: "Property",
    taxYear: 2020,
    account: 1843819,
    paid: false,
    amount: 223.12,
  },
  {
    ownerName: "Yoshiko Birkbeck",
    recordType: "Property",
    taxYear: 2020,
    account: 1802611,
    paid: true,
    amount: 42.32,
  },
  {
    ownerName: "Silvana Petyakov",
    recordType: "Property",
    taxYear: 2020,
    account: 1693747,
    paid: true,
    amount: 152.58,
  },
  {
    ownerName: "Theobald Antonovic",
    recordType: "Property",
    taxYear: 2020,
    account: 1362283,
    paid: true,
    amount: 120.5,
  },
  {
    ownerName: "Andrea Summergill",
    recordType: "Property",
    taxYear: 2020,
    account: 1974651,
    paid: false,
    amount: 460.46,
  },
  {
    ownerName: "Katuscha Oleszcuk",
    recordType: "Property",
    taxYear: 2020,
    account: 1722999,
    paid: false,
    amount: 91.95,
  },
  {
    ownerName: "Caren Geall",
    recordType: "Property",
    taxYear: 2020,
    account: 1618859,
    paid: false,
    amount: 281.33,
  },
  {
    ownerName: "Conni Bolletti",
    recordType: "Property",
    taxYear: 2020,
    account: 1764249,
    paid: true,
    amount: 419.01,
  },
  {
    ownerName: "Curry Insull",
    recordType: "Property",
    taxYear: 2020,
    account: 1274040,
    paid: false,
    amount: 102.85,
  },
  {
    ownerName: "Pet Rowsell",
    recordType: "Property",
    taxYear: 2020,
    account: 1293942,
    paid: false,
    amount: 129.48,
  },
  {
    ownerName: "Davey Dumbleton",
    recordType: "Property",
    taxYear: 2020,
    account: 1215113,
    paid: true,
    amount: 158.82,
  },
  {
    ownerName: "Maurizia Copeland",
    recordType: "Property",
    taxYear: 2020,
    account: 1579906,
    paid: true,
    amount: 287.38,
  },
  {
    ownerName: "Eleanore Huggett",
    recordType: "Property",
    taxYear: 2020,
    account: 1547934,
    paid: true,
    amount: 151.11,
  },
  {
    ownerName: "Cornie Upjohn",
    recordType: "Property",
    taxYear: 2020,
    account: 1464284,
    paid: false,
    amount: 354.63,
  },
  {
    ownerName: "Prudy Hoyt",
    recordType: "Property",
    taxYear: 2020,
    account: 1315961,
    paid: true,
    amount: 274.55,
  },
  {
    ownerName: "Darell Scannell",
    recordType: "Property",
    taxYear: 2020,
    account: 1983549,
    paid: true,
    amount: 290.96,
  },
  {
    ownerName: "Gale Starsmeare",
    recordType: "Property",
    taxYear: 2020,
    account: 1651799,
    paid: false,
    amount: 66.94,
  },
  {
    ownerName: "Gweneth Jimson",
    recordType: "Property",
    taxYear: 2020,
    account: 1204417,
    paid: true,
    amount: 298.7,
  },
  {
    ownerName: "Cullin Kiggel",
    recordType: "Property",
    taxYear: 2020,
    account: 1919260,
    paid: false,
    amount: 437.75,
  },
  {
    ownerName: "Mano Goschalk",
    recordType: "Property",
    taxYear: 2020,
    account: 1937780,
    paid: true,
    amount: 98.02,
  },
  {
    ownerName: "Worth Brosini",
    recordType: "Property",
    taxYear: 2020,
    account: 1959207,
    paid: false,
    amount: 269.3,
  },
  {
    ownerName: "Rhett Atmore",
    recordType: "Property",
    taxYear: 2020,
    account: 1791750,
    paid: true,
    amount: 276.98,
  },
  {
    ownerName: "Faustine Nendick",
    recordType: "Property",
    taxYear: 2020,
    account: 1956197,
    paid: true,
    amount: 411.33,
  },
  {
    ownerName: "Mirella Landa",
    recordType: "Property",
    taxYear: 2020,
    account: 1504417,
    paid: true,
    amount: 225.3,
  },
  {
    ownerName: "Asia Dandy",
    recordType: "Property",
    taxYear: 2020,
    account: 1346876,
    paid: false,
    amount: 128.4,
  },
  {
    ownerName: "Cacilie Maylor",
    recordType: "Property",
    taxYear: 2020,
    account: 1345872,
    paid: true,
    amount: 2.1,
  },
  {
    ownerName: "Cirilo Overil",
    recordType: "Property",
    taxYear: 2020,
    account: 1541369,
    paid: true,
    amount: 190.09,
  },
  {
    ownerName: "Jeffry Jelks",
    recordType: "Property",
    taxYear: 2020,
    account: 1584594,
    paid: true,
    amount: 390.51,
  },
  {
    ownerName: "Caesar Lunck",
    recordType: "Property",
    taxYear: 2020,
    account: 1812878,
    paid: true,
    amount: 286.24,
  },
  {
    ownerName: "Janis Probbings",
    recordType: "Property",
    taxYear: 2020,
    account: 1636269,
    paid: true,
    amount: 176.36,
  },
  {
    ownerName: "Vidovic Iskow",
    recordType: "Property",
    taxYear: 2020,
    account: 1443335,
    paid: false,
    amount: 316.25,
  },
  {
    ownerName: "Jacquelyn Brunstan",
    recordType: "Property",
    taxYear: 2020,
    account: 1265697,
    paid: false,
    amount: 362.21,
  },
  {
    ownerName: "Felicia Dowsett",
    recordType: "Property",
    taxYear: 2020,
    account: 1846261,
    paid: false,
    amount: 290.65,
  },
  {
    ownerName: "Pincus Covelle",
    recordType: "Property",
    taxYear: 2020,
    account: 1275721,
    paid: false,
    amount: 200.49,
  },
  {
    ownerName: "Romonda Oxlade",
    recordType: "Property",
    taxYear: 2020,
    account: 1448845,
    paid: false,
    amount: 158.91,
  },
  {
    ownerName: "Sidney Zoanetti",
    recordType: "Property",
    taxYear: 2020,
    account: 1394559,
    paid: false,
    amount: 368.29,
  },
  {
    ownerName: "Rici Casillas",
    recordType: "Property",
    taxYear: 2020,
    account: 1824764,
    paid: false,
    amount: 383.22,
  },
  {
    ownerName: "Caspar Pym",
    recordType: "Property",
    taxYear: 2020,
    account: 1584285,
    paid: false,
    amount: 394.9,
  },
  {
    ownerName: "Leonhard Dedrick",
    recordType: "Property",
    taxYear: 2020,
    account: 1768225,
    paid: false,
    amount: 341.32,
  },
  {
    ownerName: "Alvan Ridolfo",
    recordType: "Property",
    taxYear: 2020,
    account: 1366310,
    paid: true,
    amount: 148.02,
  },
  {
    ownerName: "Hedi Dalliwatr",
    recordType: "Property",
    taxYear: 2020,
    account: 1472039,
    paid: true,
    amount: 452.39,
  },
  {
    ownerName: "Cairistiona Mucci",
    recordType: "Property",
    taxYear: 2020,
    account: 1835785,
    paid: true,
    amount: 212.72,
  },
  {
    ownerName: "Lesly Seeney",
    recordType: "Property",
    taxYear: 2020,
    account: 1208159,
    paid: false,
    amount: 29.24,
  },
  {
    ownerName: "Forester Penson",
    recordType: "Property",
    taxYear: 2020,
    account: 1525835,
    paid: false,
    amount: 132.24,
  },
  {
    ownerName: "Marjory Layson",
    recordType: "Property",
    taxYear: 2020,
    account: 1745756,
    paid: true,
    amount: 51.49,
  },
  {
    ownerName: "Daria Greader",
    recordType: "Property",
    taxYear: 2020,
    account: 1639400,
    paid: true,
    amount: 234.14,
  },
  {
    ownerName: "Jasmine Laverack",
    recordType: "Property",
    taxYear: 2020,
    account: 1696718,
    paid: false,
    amount: 65.08,
  },
  {
    ownerName: "Jeanette Curado",
    recordType: "Property",
    taxYear: 2020,
    account: 1791297,
    paid: true,
    amount: 495.07,
  },
  {
    ownerName: "Grover Trewartha",
    recordType: "Property",
    taxYear: 2020,
    account: 1554481,
    paid: false,
    amount: 152.09,
  },
  {
    ownerName: "Gweneth Rae",
    recordType: "Property",
    taxYear: 2020,
    account: 1730075,
    paid: false,
    amount: 49.23,
  },
  {
    ownerName: "Clarette Tremonte",
    recordType: "Property",
    taxYear: 2020,
    account: 1277930,
    paid: false,
    amount: 356.54,
  },
  {
    ownerName: "Mallory Simao",
    recordType: "Property",
    taxYear: 2020,
    account: 1500774,
    paid: false,
    amount: 232.84,
  },
  {
    ownerName: "Kacie Drews",
    recordType: "Property",
    taxYear: 2020,
    account: 1688559,
    paid: false,
    amount: 49.01,
  },
  {
    ownerName: "Nels Berryman",
    recordType: "Property",
    taxYear: 2020,
    account: 1580483,
    paid: true,
    amount: 67.18,
  },
  {
    ownerName: "Winonah Ghidoni",
    recordType: "Property",
    taxYear: 2020,
    account: 1900204,
    paid: true,
    amount: 499.64,
  },
  {
    ownerName: "Bryon Flury",
    recordType: "Property",
    taxYear: 2020,
    account: 1796479,
    paid: false,
    amount: 168.51,
  },
  {
    ownerName: "Dew Faulks",
    recordType: "Property",
    taxYear: 2020,
    account: 1860383,
    paid: false,
    amount: 375.62,
  },
  {
    ownerName: "Dreddy McCully",
    recordType: "Property",
    taxYear: 2020,
    account: 1462923,
    paid: false,
    amount: 491.78,
  },
  {
    ownerName: "Rory Bayly",
    recordType: "Property",
    taxYear: 2020,
    account: 1725571,
    paid: true,
    amount: 349.34,
  },
  {
    ownerName: "Aldin Sebrook",
    recordType: "Property",
    taxYear: 2020,
    account: 1462389,
    paid: false,
    amount: 131.74,
  },
  {
    ownerName: "Sheeree Woolpert",
    recordType: "Property",
    taxYear: 2020,
    account: 1558502,
    paid: true,
    amount: 148.03,
  },
  {
    ownerName: "Othella Vasse",
    recordType: "Property",
    taxYear: 2020,
    account: 1452537,
    paid: false,
    amount: 66.28,
  },
  {
    ownerName: "Amelia Rallings",
    recordType: "Property",
    taxYear: 2020,
    account: 1367619,
    paid: false,
    amount: 277.14,
  },
  {
    ownerName: "Ulrike Nekrews",
    recordType: "Property",
    taxYear: 2020,
    account: 1461655,
    paid: false,
    amount: 205.32,
  },
  {
    ownerName: "Tawnya Thiem",
    recordType: "Property",
    taxYear: 2020,
    account: 1483429,
    paid: false,
    amount: 69.03,
  },
  {
    ownerName: "Reese Spottswood",
    recordType: "Property",
    taxYear: 2020,
    account: 1204594,
    paid: false,
    amount: 393.39,
  },
  {
    ownerName: "Cordelia Ashbridge",
    recordType: "Property",
    taxYear: 2020,
    account: 1227205,
    paid: false,
    amount: 144.65,
  },
  {
    ownerName: "Perle Blakeborough",
    recordType: "Property",
    taxYear: 2020,
    account: 1317311,
    paid: false,
    amount: 381.99,
  },
  {
    ownerName: "Lotty Redan",
    recordType: "Property",
    taxYear: 2020,
    account: 1411356,
    paid: true,
    amount: 358.8,
  },
  {
    ownerName: "Blakeley McFee",
    recordType: "Property",
    taxYear: 2020,
    account: 1207307,
    paid: true,
    amount: 170.41,
  },
  {
    ownerName: "Dix Riglar",
    recordType: "Property",
    taxYear: 2020,
    account: 1984720,
    paid: true,
    amount: 346.39,
  },
  {
    ownerName: "Shannen Claque",
    recordType: "Property",
    taxYear: 2020,
    account: 1816600,
    paid: true,
    amount: 258.15,
  },
  {
    ownerName: "Rani Stenyng",
    recordType: "Property",
    taxYear: 2020,
    account: 1589441,
    paid: true,
    amount: 335.29,
  },
  {
    ownerName: "Chrissy Maggill'Andreis",
    recordType: "Property",
    taxYear: 2020,
    account: 1238729,
    paid: false,
    amount: 388.65,
  },
  {
    ownerName: "Rickey Catterall",
    recordType: "Property",
    taxYear: 2020,
    account: 1404281,
    paid: false,
    amount: 29.17,
  },
  {
    ownerName: "Nev Barrowclough",
    recordType: "Property",
    taxYear: 2020,
    account: 1326320,
    paid: true,
    amount: 339.4,
  },
  {
    ownerName: "Benedikt Fry",
    recordType: "Property",
    taxYear: 2020,
    account: 1662398,
    paid: true,
    amount: 271.85,
  },
  {
    ownerName: "Minette Crollman",
    recordType: "Property",
    taxYear: 2020,
    account: 1325601,
    paid: false,
    amount: 422.93,
  },
  {
    ownerName: "Erna Gibling",
    recordType: "Property",
    taxYear: 2020,
    account: 1443284,
    paid: false,
    amount: 20.63,
  },
  {
    ownerName: "Horatius Chateau",
    recordType: "Property",
    taxYear: 2020,
    account: 1360357,
    paid: false,
    amount: 377.79,
  },
  {
    ownerName: "Nolly Francey",
    recordType: "Property",
    taxYear: 2020,
    account: 1274201,
    paid: false,
    amount: 154.02,
  },
  {
    ownerName: "Brittni D'Agostini",
    recordType: "Property",
    taxYear: 2020,
    account: 1437360,
    paid: false,
    amount: 344.0,
  },
  {
    ownerName: "Letta Foch",
    recordType: "Property",
    taxYear: 2020,
    account: 1509702,
    paid: true,
    amount: 490.62,
  },
  {
    ownerName: "Nessy Demcik",
    recordType: "Property",
    taxYear: 2020,
    account: 1372401,
    paid: true,
    amount: 122.77,
  },
  {
    ownerName: "Cherri Bohlens",
    recordType: "Property",
    taxYear: 2020,
    account: 1798336,
    paid: true,
    amount: 88.39,
  },
  {
    ownerName: "Calv Sired",
    recordType: "Property",
    taxYear: 2020,
    account: 1354735,
    paid: true,
    amount: 260.68,
  },
  {
    ownerName: "Jan Shwalbe",
    recordType: "Property",
    taxYear: 2020,
    account: 1452479,
    paid: true,
    amount: 178.8,
  },
  {
    ownerName: "Gisela Lapley",
    recordType: "Property",
    taxYear: 2020,
    account: 1339826,
    paid: false,
    amount: 320.89,
  },
  {
    ownerName: "Karylin Pigden",
    recordType: "Property",
    taxYear: 2020,
    account: 1990264,
    paid: true,
    amount: 52.62,
  },
  {
    ownerName: "Andros Atyea",
    recordType: "Property",
    taxYear: 2020,
    account: 1557484,
    paid: true,
    amount: 280.05,
  },
  {
    ownerName: "Corie Whitaker",
    recordType: "Property",
    taxYear: 2020,
    account: 1383463,
    paid: true,
    amount: 278.22,
  },
  {
    ownerName: "Kari Nockolds",
    recordType: "Property",
    taxYear: 2020,
    account: 1233291,
    paid: true,
    amount: 412.92,
  },
  {
    ownerName: "Olia Braham",
    recordType: "Property",
    taxYear: 2020,
    account: 1369874,
    paid: true,
    amount: 139.18,
  },
  {
    ownerName: "Debora Saintsbury",
    recordType: "Property",
    taxYear: 2020,
    account: 1686413,
    paid: false,
    amount: 368.5,
  },
  {
    ownerName: "Bartie McPhee",
    recordType: "Property",
    taxYear: 2020,
    account: 1461232,
    paid: false,
    amount: 271.82,
  },
  {
    ownerName: "Warden Grizard",
    recordType: "Property",
    taxYear: 2020,
    account: 1752372,
    paid: false,
    amount: 328.43,
  },
  {
    ownerName: "Sloan Butt Gow",
    recordType: "Property",
    taxYear: 2020,
    account: 1245616,
    paid: false,
    amount: 185.44,
  },
  {
    ownerName: "Sol Kail",
    recordType: "Property",
    taxYear: 2020,
    account: 1512936,
    paid: false,
    amount: 136.9,
  },
  {
    ownerName: "Ileana Schachter",
    recordType: "Property",
    taxYear: 2020,
    account: 1988512,
    paid: true,
    amount: 445.05,
  },
  {
    ownerName: "Bartholomeus Frise",
    recordType: "Property",
    taxYear: 2020,
    account: 1535983,
    paid: false,
    amount: 405.4,
  },
  {
    ownerName: "Jasun Fraulo",
    recordType: "Property",
    taxYear: 2020,
    account: 1733467,
    paid: false,
    amount: 471.37,
  },
  {
    ownerName: "Bertha Wesley",
    recordType: "Property",
    taxYear: 2020,
    account: 1210073,
    paid: true,
    amount: 272.39,
  },
  {
    ownerName: "Mitch Larcher",
    recordType: "Property",
    taxYear: 2020,
    account: 1923346,
    paid: false,
    amount: 381.99,
  },
  {
    ownerName: "Karry Stolle",
    recordType: "Property",
    taxYear: 2020,
    account: 1532357,
    paid: false,
    amount: 314.36,
  },
  {
    ownerName: "Vlad Lamswood",
    recordType: "Property",
    taxYear: 2020,
    account: 1447710,
    paid: false,
    amount: 37.77,
  },
  {
    ownerName: "Donal Rudolf",
    recordType: "Property",
    taxYear: 2020,
    account: 1856925,
    paid: true,
    amount: 100.93,
  },
  {
    ownerName: "Rosabel Beckwith",
    recordType: "Property",
    taxYear: 2020,
    account: 1318940,
    paid: false,
    amount: 265.25,
  },
  {
    ownerName: "Tildie Dahl",
    recordType: "Property",
    taxYear: 2020,
    account: 1213015,
    paid: false,
    amount: 164.39,
  },
  {
    ownerName: "Malynda Bruineman",
    recordType: "Property",
    taxYear: 2020,
    account: 1318639,
    paid: false,
    amount: 123.99,
  },
  {
    ownerName: "Darnall Pinfold",
    recordType: "Property",
    taxYear: 2020,
    account: 1265934,
    paid: true,
    amount: 169.56,
  },
  {
    ownerName: "Abey Skittle",
    recordType: "Property",
    taxYear: 2020,
    account: 1903030,
    paid: true,
    amount: 498.59,
  },
  {
    ownerName: "Olly Mellody",
    recordType: "Property",
    taxYear: 2020,
    account: 1213726,
    paid: true,
    amount: 299.29,
  },
  {
    ownerName: "Nata Craik",
    recordType: "Property",
    taxYear: 2020,
    account: 1406483,
    paid: true,
    amount: 387.99,
  },
  {
    ownerName: "Jacinta Neising",
    recordType: "Property",
    taxYear: 2020,
    account: 1296601,
    paid: true,
    amount: 118.24,
  },
  {
    ownerName: "Vasily Dyerson",
    recordType: "Property",
    taxYear: 2020,
    account: 1308812,
    paid: false,
    amount: 138.81,
  },
  {
    ownerName: "Lorne Covolini",
    recordType: "Property",
    taxYear: 2020,
    account: 1976470,
    paid: false,
    amount: 297.54,
  },
  {
    ownerName: "Dill Witherington",
    recordType: "Property",
    taxYear: 2020,
    account: 1768658,
    paid: false,
    amount: 76.36,
  },
  {
    ownerName: "Gabrielle Joynson",
    recordType: "Property",
    taxYear: 2020,
    account: 1232027,
    paid: true,
    amount: 430.25,
  },
  {
    ownerName: "Rad Moiser",
    recordType: "Property",
    taxYear: 2020,
    account: 1414299,
    paid: false,
    amount: 101.91,
  },
  {
    ownerName: "Wren Hugett",
    recordType: "Property",
    taxYear: 2020,
    account: 1388066,
    paid: true,
    amount: 397.51,
  },
  {
    ownerName: "Fredi Huntall",
    recordType: "Property",
    taxYear: 2020,
    account: 1831862,
    paid: false,
    amount: 286.97,
  },
  {
    ownerName: "Frederico Sharpling",
    recordType: "Property",
    taxYear: 2020,
    account: 1964814,
    paid: true,
    amount: 183.42,
  },
  {
    ownerName: "Bay De Beauchemp",
    recordType: "Property",
    taxYear: 2020,
    account: 1434714,
    paid: false,
    amount: 6.34,
  },
  {
    ownerName: "Dario Widdup",
    recordType: "Property",
    taxYear: 2020,
    account: 1977445,
    paid: false,
    amount: 27.88,
  },
  {
    ownerName: "Nikolas Martugin",
    recordType: "Property",
    taxYear: 2020,
    account: 1527680,
    paid: true,
    amount: 22.08,
  },
  {
    ownerName: "Pavla Pabst",
    recordType: "Property",
    taxYear: 2020,
    account: 1540433,
    paid: false,
    amount: 424.39,
  },
  {
    ownerName: "Jamaal Challicum",
    recordType: "Property",
    taxYear: 2020,
    account: 1829263,
    paid: false,
    amount: 442.13,
  },
  {
    ownerName: "Winny Carswell",
    recordType: "Property",
    taxYear: 2020,
    account: 1682863,
    paid: false,
    amount: 434.25,
  },
  {
    ownerName: "Anna-maria Winsom",
    recordType: "Property",
    taxYear: 2020,
    account: 1403240,
    paid: true,
    amount: 339.67,
  },
  {
    ownerName: "Rick Bunton",
    recordType: "Property",
    taxYear: 2020,
    account: 1894317,
    paid: true,
    amount: 243.65,
  },
  {
    ownerName: "Townsend Lagen",
    recordType: "Property",
    taxYear: 2020,
    account: 1606812,
    paid: false,
    amount: 43.07,
  },
  {
    ownerName: "Jeniece Dows",
    recordType: "Property",
    taxYear: 2020,
    account: 1622576,
    paid: true,
    amount: 451.59,
  },
  {
    ownerName: "Max Manach",
    recordType: "Property",
    taxYear: 2020,
    account: 1261607,
    paid: true,
    amount: 452.67,
  },
  {
    ownerName: "Bat Howels",
    recordType: "Property",
    taxYear: 2020,
    account: 1680043,
    paid: false,
    amount: 320.84,
  },
  {
    ownerName: "Jamie Bree",
    recordType: "Property",
    taxYear: 2020,
    account: 1929593,
    paid: true,
    amount: 374.24,
  },
  {
    ownerName: "Wilhelmine Pagen",
    recordType: "Property",
    taxYear: 2020,
    account: 1939690,
    paid: true,
    amount: 73.06,
  },
  {
    ownerName: "Katharine Jime",
    recordType: "Property",
    taxYear: 2020,
    account: 1778959,
    paid: false,
    amount: 279.83,
  },
  {
    ownerName: "Forbes Aronsohn",
    recordType: "Property",
    taxYear: 2020,
    account: 1624908,
    paid: false,
    amount: 368.52,
  },
  {
    ownerName: "Dewain Doidge",
    recordType: "Property",
    taxYear: 2020,
    account: 1733748,
    paid: false,
    amount: 415.49,
  },
  {
    ownerName: "Jude Rosenshine",
    recordType: "Property",
    taxYear: 2020,
    account: 1425486,
    paid: true,
    amount: 94.59,
  },
  {
    ownerName: "Langsdon Cottey",
    recordType: "Property",
    taxYear: 2020,
    account: 1214035,
    paid: true,
    amount: 362.71,
  },
  {
    ownerName: "Berri Kollatsch",
    recordType: "Property",
    taxYear: 2020,
    account: 1622596,
    paid: false,
    amount: 289.03,
  },
  {
    ownerName: "Bettye Gossage",
    recordType: "Property",
    taxYear: 2020,
    account: 1302448,
    paid: true,
    amount: 398.13,
  },
  {
    ownerName: "Cordelie Parke",
    recordType: "Property",
    taxYear: 2020,
    account: 1342615,
    paid: false,
    amount: 102.4,
  },
  {
    ownerName: "Augusta Pybus",
    recordType: "Property",
    taxYear: 2020,
    account: 1517068,
    paid: false,
    amount: 377.53,
  },
  {
    ownerName: "Eliot Petrasek",
    recordType: "Property",
    taxYear: 2020,
    account: 1820612,
    paid: true,
    amount: 240.73,
  },
  {
    ownerName: "Tommi Meddings",
    recordType: "Property",
    taxYear: 2020,
    account: 1533214,
    paid: true,
    amount: 172.51,
  },
  {
    ownerName: "Huntley Skitteral",
    recordType: "Property",
    taxYear: 2020,
    account: 1815136,
    paid: true,
    amount: 70.9,
  },
  {
    ownerName: "Kippy Satterfitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1959509,
    paid: true,
    amount: 278.94,
  },
  {
    ownerName: "Emiline Tallyn",
    recordType: "Property",
    taxYear: 2020,
    account: 1445415,
    paid: true,
    amount: 266.24,
  },
  {
    ownerName: "Alyss Maseyk",
    recordType: "Property",
    taxYear: 2020,
    account: 1448365,
    paid: false,
    amount: 461.7,
  },
  {
    ownerName: "Tina Gulberg",
    recordType: "Property",
    taxYear: 2020,
    account: 1757574,
    paid: true,
    amount: 172.84,
  },
  {
    ownerName: "Yule Baggot",
    recordType: "Property",
    taxYear: 2020,
    account: 1735257,
    paid: true,
    amount: 440.07,
  },
  {
    ownerName: "Redd McGinnell",
    recordType: "Property",
    taxYear: 2020,
    account: 1528021,
    paid: true,
    amount: 497.33,
  },
  {
    ownerName: "Fanechka Girton",
    recordType: "Property",
    taxYear: 2020,
    account: 1636171,
    paid: false,
    amount: 4.08,
  },
  {
    ownerName: "Corena Lindsey",
    recordType: "Property",
    taxYear: 2020,
    account: 1610570,
    paid: true,
    amount: 499.2,
  },
  {
    ownerName: "Reinold Taillard",
    recordType: "Property",
    taxYear: 2020,
    account: 1992779,
    paid: false,
    amount: 495.0,
  },
  {
    ownerName: "Nona Neville",
    recordType: "Property",
    taxYear: 2020,
    account: 1314982,
    paid: true,
    amount: 427.86,
  },
  {
    ownerName: "Grata Wallege",
    recordType: "Property",
    taxYear: 2020,
    account: 1793468,
    paid: true,
    amount: 94.45,
  },
  {
    ownerName: "Raul Lardner",
    recordType: "Property",
    taxYear: 2020,
    account: 1287690,
    paid: false,
    amount: 233.06,
  },
  {
    ownerName: "Lisabeth McKeag",
    recordType: "Property",
    taxYear: 2020,
    account: 1790089,
    paid: true,
    amount: 231.04,
  },
  {
    ownerName: "Sydel Pead",
    recordType: "Property",
    taxYear: 2020,
    account: 1820760,
    paid: false,
    amount: 403.1,
  },
  {
    ownerName: "Josefina Buckler",
    recordType: "Property",
    taxYear: 2020,
    account: 1415200,
    paid: false,
    amount: 74.89,
  },
  {
    ownerName: "Ignaz Wride",
    recordType: "Property",
    taxYear: 2020,
    account: 1391520,
    paid: false,
    amount: 126.82,
  },
  {
    ownerName: "Valle Licquorish",
    recordType: "Property",
    taxYear: 2020,
    account: 1235676,
    paid: false,
    amount: 451.23,
  },
  {
    ownerName: "Burton Tranfield",
    recordType: "Property",
    taxYear: 2020,
    account: 1875700,
    paid: true,
    amount: 194.7,
  },
  {
    ownerName: "Jasmine Maypowder",
    recordType: "Property",
    taxYear: 2020,
    account: 1812494,
    paid: true,
    amount: 145.26,
  },
  {
    ownerName: "Harriott Lindenbluth",
    recordType: "Property",
    taxYear: 2020,
    account: 1545239,
    paid: true,
    amount: 350.24,
  },
  {
    ownerName: "Cheston Blase",
    recordType: "Property",
    taxYear: 2020,
    account: 1964995,
    paid: true,
    amount: 257.56,
  },
  {
    ownerName: "Christy Lander",
    recordType: "Property",
    taxYear: 2020,
    account: 1519943,
    paid: true,
    amount: 278.4,
  },
  {
    ownerName: "Gretal Neeves",
    recordType: "Property",
    taxYear: 2020,
    account: 1579757,
    paid: false,
    amount: 275.48,
  },
  {
    ownerName: "Dorothy Painten",
    recordType: "Property",
    taxYear: 2020,
    account: 1212244,
    paid: true,
    amount: 358.36,
  },
  {
    ownerName: "Tommie Perse",
    recordType: "Property",
    taxYear: 2020,
    account: 1384303,
    paid: false,
    amount: 52.19,
  },
  {
    ownerName: "Heidi Whiffen",
    recordType: "Property",
    taxYear: 2020,
    account: 1252504,
    paid: false,
    amount: 238.02,
  },
  {
    ownerName: "Emiline Witherby",
    recordType: "Property",
    taxYear: 2020,
    account: 1221223,
    paid: true,
    amount: 355.49,
  },
  {
    ownerName: "Merci Eisold",
    recordType: "Property",
    taxYear: 2020,
    account: 1977397,
    paid: true,
    amount: 163.55,
  },
  {
    ownerName: "Henri Gauthorpp",
    recordType: "Property",
    taxYear: 2020,
    account: 1801388,
    paid: true,
    amount: 290.43,
  },
  {
    ownerName: "Clarey Luckes",
    recordType: "Property",
    taxYear: 2020,
    account: 1918090,
    paid: true,
    amount: 26.46,
  },
  {
    ownerName: "Grace Passo",
    recordType: "Property",
    taxYear: 2020,
    account: 1807283,
    paid: false,
    amount: 386.65,
  },
  {
    ownerName: "Dosi Yitzovitz",
    recordType: "Property",
    taxYear: 2020,
    account: 1393119,
    paid: true,
    amount: 76.95,
  },
  {
    ownerName: "Fey Moniker",
    recordType: "Property",
    taxYear: 2020,
    account: 1898102,
    paid: true,
    amount: 286.97,
  },
  {
    ownerName: "Skipp Digwood",
    recordType: "Property",
    taxYear: 2020,
    account: 1937042,
    paid: false,
    amount: 83.87,
  },
  {
    ownerName: "Juieta Blaxland",
    recordType: "Property",
    taxYear: 2020,
    account: 1861041,
    paid: true,
    amount: 352.48,
  },
  {
    ownerName: "Odella McAuley",
    recordType: "Property",
    taxYear: 2020,
    account: 1569285,
    paid: true,
    amount: 72.58,
  },
  {
    ownerName: "Willy Evins",
    recordType: "Property",
    taxYear: 2020,
    account: 1785682,
    paid: false,
    amount: 310.28,
  },
  {
    ownerName: "Yale Castillou",
    recordType: "Property",
    taxYear: 2020,
    account: 1678406,
    paid: false,
    amount: 466.09,
  },
  {
    ownerName: "Abagael MacCarlich",
    recordType: "Property",
    taxYear: 2020,
    account: 1648923,
    paid: false,
    amount: 46.74,
  },
  {
    ownerName: "Ola Adie",
    recordType: "Property",
    taxYear: 2020,
    account: 1544085,
    paid: false,
    amount: 100.11,
  },
  {
    ownerName: "Lavinie Jakubovski",
    recordType: "Property",
    taxYear: 2020,
    account: 1269617,
    paid: false,
    amount: 392.36,
  },
  {
    ownerName: "Lisha Mandrier",
    recordType: "Property",
    taxYear: 2020,
    account: 1386463,
    paid: false,
    amount: 489.36,
  },
  {
    ownerName: "Janean Crossgrove",
    recordType: "Property",
    taxYear: 2020,
    account: 1705771,
    paid: true,
    amount: 81.89,
  },
  {
    ownerName: "Merci Fabbri",
    recordType: "Property",
    taxYear: 2020,
    account: 1858732,
    paid: false,
    amount: 117.89,
  },
  {
    ownerName: "Wynny Snepp",
    recordType: "Property",
    taxYear: 2020,
    account: 1696524,
    paid: false,
    amount: 166.37,
  },
  {
    ownerName: "Rahal Hearsey",
    recordType: "Property",
    taxYear: 2020,
    account: 1625931,
    paid: true,
    amount: 141.23,
  },
  {
    ownerName: "Brendan Swannick",
    recordType: "Property",
    taxYear: 2020,
    account: 1617071,
    paid: false,
    amount: 292.25,
  },
  {
    ownerName: "Tad Weddeburn - Scrimgeour",
    recordType: "Property",
    taxYear: 2020,
    account: 1786382,
    paid: true,
    amount: 473.25,
  },
  {
    ownerName: "Koenraad Petyakov",
    recordType: "Property",
    taxYear: 2020,
    account: 1742134,
    paid: true,
    amount: 456.79,
  },
  {
    ownerName: "Jerry Allbrook",
    recordType: "Property",
    taxYear: 2020,
    account: 1770864,
    paid: false,
    amount: 58.73,
  },
  {
    ownerName: "Crichton Camock",
    recordType: "Property",
    taxYear: 2020,
    account: 1573655,
    paid: false,
    amount: 123.05,
  },
  {
    ownerName: "Gaspar Varnals",
    recordType: "Property",
    taxYear: 2020,
    account: 1805187,
    paid: true,
    amount: 27.3,
  },
  {
    ownerName: "Shanta Swainger",
    recordType: "Property",
    taxYear: 2020,
    account: 1296283,
    paid: true,
    amount: 36.27,
  },
  {
    ownerName: "Diena Laverack",
    recordType: "Property",
    taxYear: 2020,
    account: 1229770,
    paid: false,
    amount: 206.24,
  },
  {
    ownerName: "Sayers Farleigh",
    recordType: "Property",
    taxYear: 2020,
    account: 1375032,
    paid: true,
    amount: 285.11,
  },
  {
    ownerName: "Olia Duce",
    recordType: "Property",
    taxYear: 2020,
    account: 1410703,
    paid: true,
    amount: 208.87,
  },
  {
    ownerName: "Jeniece Courtier",
    recordType: "Property",
    taxYear: 2020,
    account: 1303557,
    paid: false,
    amount: 189.79,
  },
  {
    ownerName: "Kellen MacCartan",
    recordType: "Property",
    taxYear: 2020,
    account: 1248426,
    paid: true,
    amount: 427.95,
  },
  {
    ownerName: "Michaeline Soigoux",
    recordType: "Property",
    taxYear: 2020,
    account: 1887157,
    paid: false,
    amount: 428.88,
  },
  {
    ownerName: "Lynde Varley",
    recordType: "Property",
    taxYear: 2020,
    account: 1677881,
    paid: true,
    amount: 228.66,
  },
  {
    ownerName: "Nichol Turneux",
    recordType: "Property",
    taxYear: 2020,
    account: 1383824,
    paid: false,
    amount: 297.76,
  },
  {
    ownerName: "Jacquenette Hellmer",
    recordType: "Property",
    taxYear: 2020,
    account: 1236208,
    paid: true,
    amount: 316.4,
  },
  {
    ownerName: "Fabiano Scoterbosh",
    recordType: "Property",
    taxYear: 2020,
    account: 1323062,
    paid: true,
    amount: 88.78,
  },
  {
    ownerName: "Borden Cuphus",
    recordType: "Property",
    taxYear: 2020,
    account: 1365808,
    paid: false,
    amount: 125.97,
  },
  {
    ownerName: "Nixie Rozenbaum",
    recordType: "Property",
    taxYear: 2020,
    account: 1281078,
    paid: false,
    amount: 20.36,
  },
  {
    ownerName: "Othella Labden",
    recordType: "Property",
    taxYear: 2020,
    account: 1414205,
    paid: true,
    amount: 254.5,
  },
  {
    ownerName: "Donelle Skuse",
    recordType: "Property",
    taxYear: 2020,
    account: 1775430,
    paid: true,
    amount: 381.95,
  },
  {
    ownerName: "Rahel Tamsett",
    recordType: "Property",
    taxYear: 2020,
    account: 1832167,
    paid: false,
    amount: 431.86,
  },
  {
    ownerName: "Whitman Hector",
    recordType: "Property",
    taxYear: 2020,
    account: 1537277,
    paid: false,
    amount: 230.66,
  },
  {
    ownerName: "Ryley Demangeon",
    recordType: "Property",
    taxYear: 2020,
    account: 1514945,
    paid: true,
    amount: 359.65,
  },
  {
    ownerName: "Jodie Awde",
    recordType: "Property",
    taxYear: 2020,
    account: 1278458,
    paid: true,
    amount: 90.8,
  },
  {
    ownerName: "Emelia Sharer",
    recordType: "Property",
    taxYear: 2020,
    account: 1432626,
    paid: false,
    amount: 296.94,
  },
  {
    ownerName: "Gordie Absolon",
    recordType: "Property",
    taxYear: 2020,
    account: 1571938,
    paid: true,
    amount: 214.58,
  },
  {
    ownerName: "Maximo Aked",
    recordType: "Property",
    taxYear: 2020,
    account: 1259351,
    paid: false,
    amount: 234.68,
  },
  {
    ownerName: "Dorie Deeks",
    recordType: "Property",
    taxYear: 2020,
    account: 1942239,
    paid: true,
    amount: 478.18,
  },
  {
    ownerName: "Kerry Kinloch",
    recordType: "Property",
    taxYear: 2020,
    account: 1453777,
    paid: false,
    amount: 376.4,
  },
  {
    ownerName: "Renelle Allain",
    recordType: "Property",
    taxYear: 2020,
    account: 1953229,
    paid: false,
    amount: 430.44,
  },
  {
    ownerName: "Wald Pavic",
    recordType: "Property",
    taxYear: 2020,
    account: 1758091,
    paid: true,
    amount: 291.68,
  },
  {
    ownerName: "Aurore Kibard",
    recordType: "Property",
    taxYear: 2020,
    account: 1988970,
    paid: true,
    amount: 414.39,
  },
  {
    ownerName: "Novelia Cardwell",
    recordType: "Property",
    taxYear: 2020,
    account: 1862814,
    paid: true,
    amount: 241.02,
  },
  {
    ownerName: "Myrta Bailiss",
    recordType: "Property",
    taxYear: 2020,
    account: 1633741,
    paid: true,
    amount: 189.62,
  },
  {
    ownerName: "Wren Coleby",
    recordType: "Property",
    taxYear: 2020,
    account: 1553138,
    paid: false,
    amount: 41.33,
  },
  {
    ownerName: "Kyla Dukes",
    recordType: "Property",
    taxYear: 2020,
    account: 1374311,
    paid: false,
    amount: 380.52,
  },
  {
    ownerName: "Jimmy Geraldez",
    recordType: "Property",
    taxYear: 2020,
    account: 1508705,
    paid: false,
    amount: 173.34,
  },
  {
    ownerName: "Gorden Coghlin",
    recordType: "Property",
    taxYear: 2020,
    account: 1617038,
    paid: true,
    amount: 49.42,
  },
  {
    ownerName: "Earle Freer",
    recordType: "Property",
    taxYear: 2020,
    account: 1706513,
    paid: false,
    amount: 14.19,
  },
  {
    ownerName: "Yettie Pawlowicz",
    recordType: "Property",
    taxYear: 2020,
    account: 1526796,
    paid: true,
    amount: 498.43,
  },
  {
    ownerName: "Alfons Gregh",
    recordType: "Property",
    taxYear: 2020,
    account: 1835514,
    paid: true,
    amount: 86.42,
  },
  {
    ownerName: "Kelcie Spriggen",
    recordType: "Property",
    taxYear: 2020,
    account: 1374647,
    paid: true,
    amount: 219.68,
  },
  {
    ownerName: "Arlina Gaytor",
    recordType: "Property",
    taxYear: 2020,
    account: 1629847,
    paid: false,
    amount: 138.91,
  },
  {
    ownerName: "Amil Peacher",
    recordType: "Property",
    taxYear: 2020,
    account: 1613377,
    paid: false,
    amount: 36.86,
  },
  {
    ownerName: "Ezequiel Vlasenko",
    recordType: "Property",
    taxYear: 2020,
    account: 1530008,
    paid: false,
    amount: 87.58,
  },
  {
    ownerName: "Faye Loche",
    recordType: "Property",
    taxYear: 2020,
    account: 1538631,
    paid: false,
    amount: 363.34,
  },
  {
    ownerName: "Vail Moorhead",
    recordType: "Property",
    taxYear: 2020,
    account: 1818223,
    paid: false,
    amount: 254.82,
  },
  {
    ownerName: "Idalina Assad",
    recordType: "Property",
    taxYear: 2020,
    account: 1451175,
    paid: true,
    amount: 240.27,
  },
  {
    ownerName: "Monroe Clyant",
    recordType: "Property",
    taxYear: 2020,
    account: 1881823,
    paid: true,
    amount: 256.98,
  },
  {
    ownerName: "Quentin Caroli",
    recordType: "Property",
    taxYear: 2020,
    account: 1740342,
    paid: true,
    amount: 278.31,
  },
  {
    ownerName: "Donnajean Mullin",
    recordType: "Property",
    taxYear: 2020,
    account: 1793859,
    paid: false,
    amount: 388.16,
  },
  {
    ownerName: "Gilemette Gilford",
    recordType: "Property",
    taxYear: 2020,
    account: 1567434,
    paid: false,
    amount: 251.62,
  },
  {
    ownerName: "Mufinella Simenon",
    recordType: "Property",
    taxYear: 2020,
    account: 1656760,
    paid: false,
    amount: 175.82,
  },
  {
    ownerName: "Hortensia Dincke",
    recordType: "Property",
    taxYear: 2020,
    account: 1992519,
    paid: true,
    amount: 257.67,
  },
  {
    ownerName: "Mellisent Leas",
    recordType: "Property",
    taxYear: 2020,
    account: 1664361,
    paid: false,
    amount: 431.26,
  },
  {
    ownerName: "Clarita Willavoys",
    recordType: "Property",
    taxYear: 2020,
    account: 1856263,
    paid: false,
    amount: 385.59,
  },
  {
    ownerName: "Dael Millson",
    recordType: "Property",
    taxYear: 2020,
    account: 1299012,
    paid: true,
    amount: 311.57,
  },
  {
    ownerName: "Cindie Neller",
    recordType: "Property",
    taxYear: 2020,
    account: 1434122,
    paid: true,
    amount: 65.28,
  },
  {
    ownerName: "Jock Duberry",
    recordType: "Property",
    taxYear: 2020,
    account: 1462675,
    paid: true,
    amount: 348.54,
  },
  {
    ownerName: "Indira Aurelius",
    recordType: "Property",
    taxYear: 2020,
    account: 1247971,
    paid: true,
    amount: 19.74,
  },
  {
    ownerName: "Roderigo Freeberne",
    recordType: "Property",
    taxYear: 2020,
    account: 1951316,
    paid: false,
    amount: 184.32,
  },
  {
    ownerName: "Dorise Benn",
    recordType: "Property",
    taxYear: 2020,
    account: 1203051,
    paid: false,
    amount: 333.93,
  },
  {
    ownerName: "Donalt Cano",
    recordType: "Property",
    taxYear: 2020,
    account: 1751530,
    paid: true,
    amount: 70.35,
  },
  {
    ownerName: "Shirley Hales",
    recordType: "Property",
    taxYear: 2020,
    account: 1312335,
    paid: true,
    amount: 260.37,
  },
  {
    ownerName: "Conny Wyllcock",
    recordType: "Property",
    taxYear: 2020,
    account: 1604486,
    paid: true,
    amount: 90.14,
  },
  {
    ownerName: "Ram Belison",
    recordType: "Property",
    taxYear: 2020,
    account: 1501833,
    paid: true,
    amount: 85.92,
  },
  {
    ownerName: "Ediva Gandar",
    recordType: "Property",
    taxYear: 2020,
    account: 1680923,
    paid: false,
    amount: 256.65,
  },
  {
    ownerName: "Marty Kinder",
    recordType: "Property",
    taxYear: 2020,
    account: 1505260,
    paid: false,
    amount: 472.61,
  },
  {
    ownerName: "Katie Van Der Hoog",
    recordType: "Property",
    taxYear: 2020,
    account: 1258404,
    paid: false,
    amount: 358.24,
  },
  {
    ownerName: "Duky Tamsett",
    recordType: "Property",
    taxYear: 2020,
    account: 1498535,
    paid: true,
    amount: 319.86,
  },
  {
    ownerName: "Regen Swinfen",
    recordType: "Property",
    taxYear: 2020,
    account: 1523867,
    paid: false,
    amount: 451.98,
  },
  {
    ownerName: "Charla Pilcher",
    recordType: "Property",
    taxYear: 2020,
    account: 1357120,
    paid: true,
    amount: 296.08,
  },
  {
    ownerName: "Alverta Leaman",
    recordType: "Property",
    taxYear: 2020,
    account: 1201347,
    paid: false,
    amount: 60.46,
  },
  {
    ownerName: "Mary Ferne",
    recordType: "Property",
    taxYear: 2020,
    account: 1695445,
    paid: false,
    amount: 482.63,
  },
  {
    ownerName: "Katherina Brummitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1464418,
    paid: true,
    amount: 142.54,
  },
  {
    ownerName: "Wynne Gedge",
    recordType: "Property",
    taxYear: 2020,
    account: 1286966,
    paid: true,
    amount: 316.1,
  },
  {
    ownerName: "Gherardo Milton",
    recordType: "Property",
    taxYear: 2020,
    account: 1548434,
    paid: true,
    amount: 93.38,
  },
  {
    ownerName: "Merrie Roelofs",
    recordType: "Property",
    taxYear: 2020,
    account: 1917328,
    paid: false,
    amount: 298.57,
  },
  {
    ownerName: "Helena Van Waadenburg",
    recordType: "Property",
    taxYear: 2020,
    account: 1725332,
    paid: false,
    amount: 350.88,
  },
  {
    ownerName: "Marie Ambrosoni",
    recordType: "Property",
    taxYear: 2020,
    account: 1919033,
    paid: false,
    amount: 191.17,
  },
  {
    ownerName: "Mireille Calveley",
    recordType: "Property",
    taxYear: 2020,
    account: 1359900,
    paid: true,
    amount: 193.08,
  },
  {
    ownerName: "Sheffie Warrack",
    recordType: "Property",
    taxYear: 2020,
    account: 1544743,
    paid: false,
    amount: 261.99,
  },
  {
    ownerName: "Catina Skingle",
    recordType: "Property",
    taxYear: 2020,
    account: 1703607,
    paid: true,
    amount: 261.18,
  },
  {
    ownerName: "Jerrilyn Wolford",
    recordType: "Property",
    taxYear: 2020,
    account: 1540624,
    paid: true,
    amount: 325.48,
  },
  {
    ownerName: "Ardella Stilldale",
    recordType: "Property",
    taxYear: 2020,
    account: 1805125,
    paid: false,
    amount: 2.44,
  },
  {
    ownerName: "Ninnette Monkley",
    recordType: "Property",
    taxYear: 2020,
    account: 1864495,
    paid: true,
    amount: 158.56,
  },
  {
    ownerName: "Mose Abel",
    recordType: "Property",
    taxYear: 2020,
    account: 1353649,
    paid: false,
    amount: 330.5,
  },
  {
    ownerName: "Tiphani Manes",
    recordType: "Property",
    taxYear: 2020,
    account: 1217510,
    paid: true,
    amount: 378.2,
  },
  {
    ownerName: "Virgil Westoff",
    recordType: "Property",
    taxYear: 2020,
    account: 1264273,
    paid: false,
    amount: 481.14,
  },
  {
    ownerName: "Lois Corbet",
    recordType: "Property",
    taxYear: 2020,
    account: 1379638,
    paid: true,
    amount: 397.97,
  },
  {
    ownerName: "Roselin Gadney",
    recordType: "Property",
    taxYear: 2020,
    account: 1599016,
    paid: true,
    amount: 294.57,
  },
  {
    ownerName: "Katey Bockler",
    recordType: "Property",
    taxYear: 2020,
    account: 1482358,
    paid: true,
    amount: 15.35,
  },
  {
    ownerName: "Ardelis Wymer",
    recordType: "Property",
    taxYear: 2020,
    account: 1969282,
    paid: false,
    amount: 438.74,
  },
  {
    ownerName: "Matilda Hollibone",
    recordType: "Property",
    taxYear: 2020,
    account: 1639363,
    paid: false,
    amount: 40.44,
  },
  {
    ownerName: "Junina St. Quintin",
    recordType: "Property",
    taxYear: 2020,
    account: 1588193,
    paid: false,
    amount: 189.91,
  },
  {
    ownerName: "Keir Volette",
    recordType: "Property",
    taxYear: 2020,
    account: 1325362,
    paid: true,
    amount: 324.08,
  },
  {
    ownerName: "Cari Fusedale",
    recordType: "Property",
    taxYear: 2020,
    account: 1977478,
    paid: true,
    amount: 402.54,
  },
  {
    ownerName: "Thorpe Ganderton",
    recordType: "Property",
    taxYear: 2020,
    account: 1715552,
    paid: false,
    amount: 342.93,
  },
  {
    ownerName: "Shana Hymus",
    recordType: "Property",
    taxYear: 2020,
    account: 1558109,
    paid: true,
    amount: 464.27,
  },
  {
    ownerName: "Honey Wylder",
    recordType: "Property",
    taxYear: 2020,
    account: 1375205,
    paid: true,
    amount: 202.98,
  },
  {
    ownerName: "Tisha Honniebal",
    recordType: "Property",
    taxYear: 2020,
    account: 1277046,
    paid: false,
    amount: 284.71,
  },
  {
    ownerName: "Gris Shadbolt",
    recordType: "Property",
    taxYear: 2020,
    account: 1869886,
    paid: true,
    amount: 458.79,
  },
  {
    ownerName: "Ariana Radcliffe",
    recordType: "Property",
    taxYear: 2020,
    account: 1210323,
    paid: false,
    amount: 438.18,
  },
  {
    ownerName: "Sonnnie Bergeau",
    recordType: "Property",
    taxYear: 2020,
    account: 1565223,
    paid: false,
    amount: 438.37,
  },
  {
    ownerName: "Mario Shilling",
    recordType: "Property",
    taxYear: 2020,
    account: 1887285,
    paid: true,
    amount: 137.55,
  },
  {
    ownerName: "Tracey Redman",
    recordType: "Property",
    taxYear: 2020,
    account: 1871236,
    paid: true,
    amount: 185.89,
  },
  {
    ownerName: "Lemuel McDougall",
    recordType: "Property",
    taxYear: 2020,
    account: 1653451,
    paid: true,
    amount: 296.71,
  },
  {
    ownerName: "Pooh Naughton",
    recordType: "Property",
    taxYear: 2020,
    account: 1523093,
    paid: true,
    amount: 461.98,
  },
  {
    ownerName: "Suzy Mizzen",
    recordType: "Property",
    taxYear: 2020,
    account: 1982799,
    paid: false,
    amount: 140.85,
  },
  {
    ownerName: "Thaxter Patershall",
    recordType: "Property",
    taxYear: 2020,
    account: 1215393,
    paid: true,
    amount: 401.95,
  },
  {
    ownerName: "Tiffie Bailes",
    recordType: "Property",
    taxYear: 2020,
    account: 1586612,
    paid: true,
    amount: 469.83,
  },
  {
    ownerName: "Hieronymus Deluca",
    recordType: "Property",
    taxYear: 2020,
    account: 1417820,
    paid: false,
    amount: 312.06,
  },
  {
    ownerName: "Collette Blakebrough",
    recordType: "Property",
    taxYear: 2020,
    account: 1815886,
    paid: true,
    amount: 53.36,
  },
  {
    ownerName: "Glory Cherrie",
    recordType: "Property",
    taxYear: 2020,
    account: 1314694,
    paid: false,
    amount: 441.81,
  },
  {
    ownerName: "Mario Collerd",
    recordType: "Property",
    taxYear: 2020,
    account: 1805655,
    paid: true,
    amount: 40.33,
  },
  {
    ownerName: "Mark McIntosh",
    recordType: "Property",
    taxYear: 2020,
    account: 1739653,
    paid: true,
    amount: 130.51,
  },
  {
    ownerName: "Orbadiah M'Barron",
    recordType: "Property",
    taxYear: 2020,
    account: 1447161,
    paid: false,
    amount: 94.75,
  },
  {
    ownerName: "Celle Boribal",
    recordType: "Property",
    taxYear: 2020,
    account: 1590834,
    paid: false,
    amount: 186.27,
  },
  {
    ownerName: "Noe Swire",
    recordType: "Property",
    taxYear: 2020,
    account: 1545107,
    paid: true,
    amount: 29.9,
  },
  {
    ownerName: "Arielle Dorr",
    recordType: "Property",
    taxYear: 2020,
    account: 1639817,
    paid: true,
    amount: 266.82,
  },
  {
    ownerName: "Suzette MacLese",
    recordType: "Property",
    taxYear: 2020,
    account: 1583455,
    paid: false,
    amount: 230.62,
  },
  {
    ownerName: "Ami Ricardot",
    recordType: "Property",
    taxYear: 2020,
    account: 1390846,
    paid: true,
    amount: 33.58,
  },
  {
    ownerName: "Ben Chantillon",
    recordType: "Property",
    taxYear: 2020,
    account: 1219465,
    paid: true,
    amount: 71.14,
  },
  {
    ownerName: "Bernadina Guitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1877866,
    paid: false,
    amount: 34.58,
  },
  {
    ownerName: "Lawton Wardell",
    recordType: "Property",
    taxYear: 2020,
    account: 1415516,
    paid: false,
    amount: 402.43,
  },
  {
    ownerName: "Ailey Waycott",
    recordType: "Property",
    taxYear: 2020,
    account: 1470673,
    paid: true,
    amount: 277.88,
  },
  {
    ownerName: "Alane Inglish",
    recordType: "Property",
    taxYear: 2020,
    account: 1209565,
    paid: true,
    amount: 306.84,
  },
  {
    ownerName: "Terrance Skully",
    recordType: "Property",
    taxYear: 2020,
    account: 1892953,
    paid: false,
    amount: 478.4,
  },
  {
    ownerName: "Any Rodmell",
    recordType: "Property",
    taxYear: 2020,
    account: 1681870,
    paid: false,
    amount: 402.52,
  },
  {
    ownerName: "Reinaldo Eliasen",
    recordType: "Property",
    taxYear: 2020,
    account: 1215581,
    paid: true,
    amount: 57.56,
  },
  {
    ownerName: "Jeannine Purseglove",
    recordType: "Property",
    taxYear: 2020,
    account: 1241320,
    paid: false,
    amount: 55.09,
  },
  {
    ownerName: "Allin Worland",
    recordType: "Property",
    taxYear: 2020,
    account: 1363539,
    paid: true,
    amount: 10.97,
  },
  {
    ownerName: "Quent Eastman",
    recordType: "Property",
    taxYear: 2020,
    account: 1495284,
    paid: true,
    amount: 110.39,
  },
  {
    ownerName: "Garwin Drohun",
    recordType: "Property",
    taxYear: 2020,
    account: 1706104,
    paid: false,
    amount: 312.73,
  },
  {
    ownerName: "Bail Hanratty",
    recordType: "Property",
    taxYear: 2020,
    account: 1672700,
    paid: true,
    amount: 486.96,
  },
  {
    ownerName: "Hoyt Mein",
    recordType: "Property",
    taxYear: 2020,
    account: 1378600,
    paid: false,
    amount: 175.98,
  },
  {
    ownerName: "Gwennie Malden",
    recordType: "Property",
    taxYear: 2020,
    account: 1901963,
    paid: false,
    amount: 123.06,
  },
  {
    ownerName: "Dick Jaray",
    recordType: "Property",
    taxYear: 2020,
    account: 1564572,
    paid: false,
    amount: 230.52,
  },
  {
    ownerName: "Byrle Slevin",
    recordType: "Property",
    taxYear: 2020,
    account: 1919093,
    paid: true,
    amount: 120.11,
  },
  {
    ownerName: "Pamela Rawnsley",
    recordType: "Property",
    taxYear: 2020,
    account: 1825674,
    paid: false,
    amount: 187.83,
  },
  {
    ownerName: "Base Cello",
    recordType: "Property",
    taxYear: 2020,
    account: 1940415,
    paid: false,
    amount: 81.42,
  },
  {
    ownerName: "Melisande Ellson",
    recordType: "Property",
    taxYear: 2020,
    account: 1514762,
    paid: true,
    amount: 416.42,
  },
  {
    ownerName: "Sayer Northgraves",
    recordType: "Property",
    taxYear: 2020,
    account: 1228104,
    paid: false,
    amount: 114.06,
  },
  {
    ownerName: "Dennis Rabbatts",
    recordType: "Property",
    taxYear: 2020,
    account: 1651054,
    paid: true,
    amount: 114.03,
  },
  {
    ownerName: "Morry MacElharge",
    recordType: "Property",
    taxYear: 2020,
    account: 1394681,
    paid: false,
    amount: 272.48,
  },
  {
    ownerName: "Aluin Ashcroft",
    recordType: "Property",
    taxYear: 2020,
    account: 1609699,
    paid: false,
    amount: 416.8,
  },
  {
    ownerName: "Iggy Beamiss",
    recordType: "Property",
    taxYear: 2020,
    account: 1499697,
    paid: true,
    amount: 96.05,
  },
  {
    ownerName: "Felicity Starzaker",
    recordType: "Property",
    taxYear: 2020,
    account: 1732269,
    paid: false,
    amount: 65.38,
  },
  {
    ownerName: "Ulysses Adamo",
    recordType: "Property",
    taxYear: 2020,
    account: 1233749,
    paid: false,
    amount: 154.75,
  },
  {
    ownerName: "Fancie Aggiss",
    recordType: "Property",
    taxYear: 2020,
    account: 1837188,
    paid: true,
    amount: 31.87,
  },
  {
    ownerName: "Jacquette Carlin",
    recordType: "Property",
    taxYear: 2020,
    account: 1893095,
    paid: true,
    amount: 186.95,
  },
  {
    ownerName: "Rori Olivier",
    recordType: "Property",
    taxYear: 2020,
    account: 1344644,
    paid: false,
    amount: 421.99,
  },
  {
    ownerName: "Evania Jovic",
    recordType: "Property",
    taxYear: 2020,
    account: 1603978,
    paid: true,
    amount: 36.33,
  },
  {
    ownerName: "Jerrie Beek",
    recordType: "Property",
    taxYear: 2020,
    account: 1954610,
    paid: true,
    amount: 419.07,
  },
  {
    ownerName: "Merwin Carluccio",
    recordType: "Property",
    taxYear: 2020,
    account: 1634095,
    paid: false,
    amount: 363.97,
  },
  {
    ownerName: "Iago Atlay",
    recordType: "Property",
    taxYear: 2020,
    account: 1391675,
    paid: true,
    amount: 85.65,
  },
  {
    ownerName: "Dicky Zamorrano",
    recordType: "Property",
    taxYear: 2020,
    account: 1324271,
    paid: false,
    amount: 313.27,
  },
  {
    ownerName: "Susanetta Kleinstern",
    recordType: "Property",
    taxYear: 2020,
    account: 1981174,
    paid: false,
    amount: 82.98,
  },
  {
    ownerName: "Christabel Eckh",
    recordType: "Property",
    taxYear: 2020,
    account: 1871846,
    paid: true,
    amount: 377.21,
  },
  {
    ownerName: "Rusty Miskelly",
    recordType: "Property",
    taxYear: 2020,
    account: 1455086,
    paid: false,
    amount: 74.17,
  },
  {
    ownerName: "Annalise Abramson",
    recordType: "Property",
    taxYear: 2020,
    account: 1372441,
    paid: false,
    amount: 292.28,
  },
  {
    ownerName: "Cordey Wheaton",
    recordType: "Property",
    taxYear: 2020,
    account: 1895149,
    paid: true,
    amount: 50.31,
  },
  {
    ownerName: "Dolorita Cracker",
    recordType: "Property",
    taxYear: 2020,
    account: 1867275,
    paid: false,
    amount: 47.36,
  },
  {
    ownerName: "Lilly McElrath",
    recordType: "Property",
    taxYear: 2020,
    account: 1656857,
    paid: true,
    amount: 191.69,
  },
  {
    ownerName: "Estell Dyne",
    recordType: "Property",
    taxYear: 2020,
    account: 1362159,
    paid: true,
    amount: 301.86,
  },
  {
    ownerName: "Elie Levine",
    recordType: "Property",
    taxYear: 2020,
    account: 1722901,
    paid: true,
    amount: 474.26,
  },
  {
    ownerName: "Ettie Littell",
    recordType: "Property",
    taxYear: 2020,
    account: 1244464,
    paid: false,
    amount: 448.49,
  },
  {
    ownerName: "Kessiah Hearne",
    recordType: "Property",
    taxYear: 2020,
    account: 1422304,
    paid: false,
    amount: 350.52,
  },
  {
    ownerName: "Ranee Bleesing",
    recordType: "Property",
    taxYear: 2020,
    account: 1526192,
    paid: true,
    amount: 85.39,
  },
  {
    ownerName: "Marylynne Vitte",
    recordType: "Property",
    taxYear: 2020,
    account: 1552702,
    paid: true,
    amount: 442.94,
  },
  {
    ownerName: "Audrye Wyatt",
    recordType: "Property",
    taxYear: 2020,
    account: 1409208,
    paid: false,
    amount: 33.91,
  },
  {
    ownerName: "Isidoro Martignoni",
    recordType: "Property",
    taxYear: 2020,
    account: 1299547,
    paid: false,
    amount: 465.68,
  },
  {
    ownerName: "Leslie Skotcher",
    recordType: "Property",
    taxYear: 2020,
    account: 1847692,
    paid: false,
    amount: 71.92,
  },
  {
    ownerName: "Steven Rosbotham",
    recordType: "Property",
    taxYear: 2020,
    account: 1618409,
    paid: false,
    amount: 102.93,
  },
  {
    ownerName: "Arlen Hovell",
    recordType: "Property",
    taxYear: 2020,
    account: 1537092,
    paid: false,
    amount: 125.93,
  },
  {
    ownerName: "Findlay Glaze",
    recordType: "Property",
    taxYear: 2020,
    account: 1653742,
    paid: false,
    amount: 141.62,
  },
  {
    ownerName: "Tessi Manns",
    recordType: "Property",
    taxYear: 2020,
    account: 1480736,
    paid: false,
    amount: 38.92,
  },
  {
    ownerName: "Ameline Stammer",
    recordType: "Property",
    taxYear: 2020,
    account: 1716451,
    paid: true,
    amount: 446.6,
  },
  {
    ownerName: "Glendon Kopf",
    recordType: "Property",
    taxYear: 2020,
    account: 1716651,
    paid: true,
    amount: 221.07,
  },
  {
    ownerName: "Anabelle Malecky",
    recordType: "Property",
    taxYear: 2020,
    account: 1414949,
    paid: true,
    amount: 244.8,
  },
  {
    ownerName: "Ramona Moretto",
    recordType: "Property",
    taxYear: 2020,
    account: 1944407,
    paid: true,
    amount: 129.5,
  },
  {
    ownerName: "Wynnie Greatham",
    recordType: "Property",
    taxYear: 2020,
    account: 1983750,
    paid: false,
    amount: 44.62,
  },
  {
    ownerName: "Honoria Mott",
    recordType: "Property",
    taxYear: 2020,
    account: 1714253,
    paid: true,
    amount: 121.72,
  },
  {
    ownerName: "Lori Ditt",
    recordType: "Property",
    taxYear: 2020,
    account: 1721448,
    paid: true,
    amount: 54.73,
  },
  {
    ownerName: "Lina Silkstone",
    recordType: "Property",
    taxYear: 2020,
    account: 1766632,
    paid: false,
    amount: 288.03,
  },
  {
    ownerName: "Delly Heber",
    recordType: "Property",
    taxYear: 2020,
    account: 1940736,
    paid: false,
    amount: 307.69,
  },
  {
    ownerName: "Goran Karchewski",
    recordType: "Property",
    taxYear: 2020,
    account: 1948595,
    paid: false,
    amount: 415.24,
  },
  {
    ownerName: "Maryann Mohan",
    recordType: "Property",
    taxYear: 2020,
    account: 1286644,
    paid: true,
    amount: 75.04,
  },
  {
    ownerName: "Courtnay Dadson",
    recordType: "Property",
    taxYear: 2020,
    account: 1808526,
    paid: false,
    amount: 314.13,
  },
  {
    ownerName: "Oates Tilby",
    recordType: "Property",
    taxYear: 2020,
    account: 1217269,
    paid: false,
    amount: 107.31,
  },
  {
    ownerName: "Cord Shawel",
    recordType: "Property",
    taxYear: 2020,
    account: 1268206,
    paid: false,
    amount: 154.92,
  },
  {
    ownerName: "Lyndel Doneld",
    recordType: "Property",
    taxYear: 2020,
    account: 1244309,
    paid: false,
    amount: 70.56,
  },
  {
    ownerName: "Janos Basek",
    recordType: "Property",
    taxYear: 2020,
    account: 1311241,
    paid: true,
    amount: 297.5,
  },
  {
    ownerName: "Claretta Hallex",
    recordType: "Property",
    taxYear: 2020,
    account: 1303814,
    paid: false,
    amount: 498.07,
  },
  {
    ownerName: "Lisette Windrass",
    recordType: "Property",
    taxYear: 2020,
    account: 1289162,
    paid: true,
    amount: 201.71,
  },
  {
    ownerName: "Timmi Grist",
    recordType: "Property",
    taxYear: 2020,
    account: 1727321,
    paid: true,
    amount: 107.88,
  },
  {
    ownerName: "Bellanca Maggiori",
    recordType: "Property",
    taxYear: 2020,
    account: 1558622,
    paid: true,
    amount: 379.49,
  },
  {
    ownerName: "Bonny Corrington",
    recordType: "Property",
    taxYear: 2020,
    account: 1924788,
    paid: true,
    amount: 78.28,
  },
  {
    ownerName: "Rodrigo Tomlett",
    recordType: "Property",
    taxYear: 2020,
    account: 1755732,
    paid: false,
    amount: 9.67,
  },
  {
    ownerName: "Brandie Snewin",
    recordType: "Property",
    taxYear: 2020,
    account: 1867378,
    paid: true,
    amount: 31.52,
  },
  {
    ownerName: "Tab Ouslem",
    recordType: "Property",
    taxYear: 2020,
    account: 1837924,
    paid: false,
    amount: 314.33,
  },
  {
    ownerName: "Maribeth Bravery",
    recordType: "Property",
    taxYear: 2020,
    account: 1981862,
    paid: false,
    amount: 24.51,
  },
  {
    ownerName: "Joelie Marchelli",
    recordType: "Property",
    taxYear: 2020,
    account: 1616218,
    paid: false,
    amount: 147.55,
  },
  {
    ownerName: "Stirling Satchel",
    recordType: "Property",
    taxYear: 2020,
    account: 1381043,
    paid: false,
    amount: 406.96,
  },
  {
    ownerName: "Rudy Bolmann",
    recordType: "Property",
    taxYear: 2020,
    account: 1222736,
    paid: false,
    amount: 185.16,
  },
  {
    ownerName: "Natasha Boam",
    recordType: "Property",
    taxYear: 2020,
    account: 1875506,
    paid: true,
    amount: 49.21,
  },
  {
    ownerName: "Jeanine Drummond",
    recordType: "Property",
    taxYear: 2020,
    account: 1489970,
    paid: true,
    amount: 147.96,
  },
  {
    ownerName: "Reade Nobbs",
    recordType: "Property",
    taxYear: 2020,
    account: 1268778,
    paid: false,
    amount: 186.89,
  },
  {
    ownerName: "Etty Habbeshaw",
    recordType: "Property",
    taxYear: 2020,
    account: 1539558,
    paid: true,
    amount: 225.61,
  },
  {
    ownerName: "Roi Tortoishell",
    recordType: "Property",
    taxYear: 2020,
    account: 1949579,
    paid: false,
    amount: 387.19,
  },
  {
    ownerName: "Pansie Zahor",
    recordType: "Property",
    taxYear: 2020,
    account: 1791517,
    paid: false,
    amount: 398.17,
  },
  {
    ownerName: "Nona Lamberts",
    recordType: "Property",
    taxYear: 2020,
    account: 1626931,
    paid: true,
    amount: 96.09,
  },
  {
    ownerName: "Christiano Brompton",
    recordType: "Property",
    taxYear: 2020,
    account: 1753719,
    paid: false,
    amount: 188.36,
  },
  {
    ownerName: "Bob Braganza",
    recordType: "Property",
    taxYear: 2020,
    account: 1882067,
    paid: false,
    amount: 308.57,
  },
  {
    ownerName: "Antoinette Escoffier",
    recordType: "Property",
    taxYear: 2020,
    account: 1462859,
    paid: false,
    amount: 316.15,
  },
  {
    ownerName: "Miranda Sailor",
    recordType: "Property",
    taxYear: 2020,
    account: 1462453,
    paid: true,
    amount: 90.2,
  },
  {
    ownerName: "Karalynn Gelsthorpe",
    recordType: "Property",
    taxYear: 2020,
    account: 1531799,
    paid: false,
    amount: 81.58,
  },
  {
    ownerName: "Rayshell Biasotti",
    recordType: "Property",
    taxYear: 2020,
    account: 1633903,
    paid: true,
    amount: 232.37,
  },
  {
    ownerName: "Clarisse Peaseman",
    recordType: "Property",
    taxYear: 2020,
    account: 1481393,
    paid: true,
    amount: 104.21,
  },
  {
    ownerName: "L;urette Yeskov",
    recordType: "Property",
    taxYear: 2020,
    account: 1788910,
    paid: true,
    amount: 236.38,
  },
  {
    ownerName: "Polly Ivy",
    recordType: "Property",
    taxYear: 2020,
    account: 1673397,
    paid: false,
    amount: 276.5,
  },
  {
    ownerName: "Bernhard Dodsworth",
    recordType: "Property",
    taxYear: 2020,
    account: 1464186,
    paid: true,
    amount: 98.97,
  },
  {
    ownerName: "Stacie Pick",
    recordType: "Property",
    taxYear: 2020,
    account: 1763752,
    paid: true,
    amount: 129.43,
  },
  {
    ownerName: "Temp Blethin",
    recordType: "Property",
    taxYear: 2020,
    account: 1527236,
    paid: false,
    amount: 394.34,
  },
  {
    ownerName: "Donovan Wilkowski",
    recordType: "Property",
    taxYear: 2020,
    account: 1670745,
    paid: true,
    amount: 455.67,
  },
  {
    ownerName: "Thomasin Colkett",
    recordType: "Property",
    taxYear: 2020,
    account: 1584469,
    paid: true,
    amount: 26.19,
  },
  {
    ownerName: "Alecia Ranns",
    recordType: "Property",
    taxYear: 2020,
    account: 1389619,
    paid: false,
    amount: 388.41,
  },
  {
    ownerName: "Matthus Pauel",
    recordType: "Property",
    taxYear: 2020,
    account: 1874632,
    paid: false,
    amount: 229.21,
  },
  {
    ownerName: "Konstance Hawket",
    recordType: "Property",
    taxYear: 2020,
    account: 1652629,
    paid: true,
    amount: 35.22,
  },
  {
    ownerName: "Russell Dinkin",
    recordType: "Property",
    taxYear: 2020,
    account: 1964500,
    paid: false,
    amount: 390.99,
  },
  {
    ownerName: "Way Muckloe",
    recordType: "Property",
    taxYear: 2020,
    account: 1750775,
    paid: false,
    amount: 474.1,
  },
  {
    ownerName: "Scotti Elfes",
    recordType: "Property",
    taxYear: 2020,
    account: 1787396,
    paid: true,
    amount: 422.79,
  },
  {
    ownerName: "Tonnie Brace",
    recordType: "Property",
    taxYear: 2020,
    account: 1201966,
    paid: true,
    amount: 356.14,
  },
  {
    ownerName: "Hanny Fielder",
    recordType: "Property",
    taxYear: 2020,
    account: 1961153,
    paid: false,
    amount: 231.59,
  },
  {
    ownerName: "Verene Streeton",
    recordType: "Property",
    taxYear: 2020,
    account: 1869574,
    paid: false,
    amount: 314.82,
  },
  {
    ownerName: "Justino Mewhirter",
    recordType: "Property",
    taxYear: 2020,
    account: 1222504,
    paid: true,
    amount: 386.38,
  },
  {
    ownerName: "D'arcy Manicom",
    recordType: "Property",
    taxYear: 2020,
    account: 1938800,
    paid: false,
    amount: 151.24,
  },
  {
    ownerName: "Weidar Dugue",
    recordType: "Property",
    taxYear: 2020,
    account: 1853966,
    paid: false,
    amount: 225.1,
  },
  {
    ownerName: "Norton Andriveaux",
    recordType: "Property",
    taxYear: 2020,
    account: 1831929,
    paid: true,
    amount: 197.67,
  },
  {
    ownerName: "Willey Dunbleton",
    recordType: "Property",
    taxYear: 2020,
    account: 1488218,
    paid: false,
    amount: 490.12,
  },
  {
    ownerName: "Inness Hynson",
    recordType: "Property",
    taxYear: 2020,
    account: 1774689,
    paid: false,
    amount: 225.73,
  },
  {
    ownerName: "Rheba Stickels",
    recordType: "Property",
    taxYear: 2020,
    account: 1686167,
    paid: false,
    amount: 44.0,
  },
  {
    ownerName: "Netti Brinkler",
    recordType: "Property",
    taxYear: 2020,
    account: 1296826,
    paid: true,
    amount: 305.35,
  },
  {
    ownerName: "Brendan Borgars",
    recordType: "Property",
    taxYear: 2020,
    account: 1918866,
    paid: true,
    amount: 433.43,
  },
  {
    ownerName: "Samara Mirando",
    recordType: "Property",
    taxYear: 2020,
    account: 1351362,
    paid: false,
    amount: 367.22,
  },
  {
    ownerName: "Alis Staner",
    recordType: "Property",
    taxYear: 2020,
    account: 1414031,
    paid: false,
    amount: 246.93,
  },
  {
    ownerName: "Kiel Jiras",
    recordType: "Property",
    taxYear: 2020,
    account: 1987087,
    paid: false,
    amount: 235.89,
  },
  {
    ownerName: "Zorine Deppe",
    recordType: "Property",
    taxYear: 2020,
    account: 1436582,
    paid: false,
    amount: 6.73,
  },
  {
    ownerName: "Bethena Kidman",
    recordType: "Property",
    taxYear: 2020,
    account: 1338372,
    paid: false,
    amount: 453.61,
  },
  {
    ownerName: "Gratia Bowring",
    recordType: "Property",
    taxYear: 2020,
    account: 1319446,
    paid: true,
    amount: 452.77,
  },
  {
    ownerName: "Corie Evenden",
    recordType: "Property",
    taxYear: 2020,
    account: 1248502,
    paid: false,
    amount: 19.27,
  },
  {
    ownerName: "Gerhard Cholton",
    recordType: "Property",
    taxYear: 2020,
    account: 1227719,
    paid: false,
    amount: 242.37,
  },
  {
    ownerName: "Christophorus Dummigan",
    recordType: "Property",
    taxYear: 2020,
    account: 1275186,
    paid: true,
    amount: 136.68,
  },
  {
    ownerName: "Asia McGrill",
    recordType: "Property",
    taxYear: 2020,
    account: 1541036,
    paid: true,
    amount: 389.7,
  },
  {
    ownerName: "Gideon Tilney",
    recordType: "Property",
    taxYear: 2020,
    account: 1548401,
    paid: true,
    amount: 273.55,
  },
  {
    ownerName: "Link Tebbit",
    recordType: "Property",
    taxYear: 2020,
    account: 1660079,
    paid: true,
    amount: 206.45,
  },
  {
    ownerName: "Cherry Ainge",
    recordType: "Property",
    taxYear: 2020,
    account: 1753017,
    paid: true,
    amount: 279.76,
  },
  {
    ownerName: "Melinde Iveans",
    recordType: "Property",
    taxYear: 2020,
    account: 1727693,
    paid: false,
    amount: 107.54,
  },
  {
    ownerName: "Rutger Redhills",
    recordType: "Property",
    taxYear: 2020,
    account: 1551704,
    paid: true,
    amount: 241.5,
  },
  {
    ownerName: "Clementine Pee",
    recordType: "Property",
    taxYear: 2020,
    account: 1665087,
    paid: false,
    amount: 13.74,
  },
  {
    ownerName: "Evvy Donett",
    recordType: "Property",
    taxYear: 2020,
    account: 1579216,
    paid: true,
    amount: 411.94,
  },
  {
    ownerName: "Walt Traise",
    recordType: "Property",
    taxYear: 2020,
    account: 1476891,
    paid: false,
    amount: 421.65,
  },
  {
    ownerName: "Andi Rable",
    recordType: "Property",
    taxYear: 2020,
    account: 1230852,
    paid: false,
    amount: 39.26,
  },
  {
    ownerName: "Willetta Tompkiss",
    recordType: "Property",
    taxYear: 2020,
    account: 1898049,
    paid: true,
    amount: 239.22,
  },
  {
    ownerName: "Vanny Mewha",
    recordType: "Property",
    taxYear: 2020,
    account: 1357494,
    paid: false,
    amount: 385.46,
  },
  {
    ownerName: "Kristal Swabey",
    recordType: "Property",
    taxYear: 2020,
    account: 1854508,
    paid: true,
    amount: 376.75,
  },
  {
    ownerName: "Caria Tenniswood",
    recordType: "Property",
    taxYear: 2020,
    account: 1370766,
    paid: false,
    amount: 16.41,
  },
  {
    ownerName: "Aarika Cossar",
    recordType: "Property",
    taxYear: 2020,
    account: 1455874,
    paid: false,
    amount: 216.08,
  },
  {
    ownerName: "Vern Castleman",
    recordType: "Property",
    taxYear: 2020,
    account: 1902858,
    paid: false,
    amount: 449.11,
  },
  {
    ownerName: "Tabby Redgrave",
    recordType: "Property",
    taxYear: 2020,
    account: 1597374,
    paid: false,
    amount: 208.23,
  },
  {
    ownerName: "Clareta Teas",
    recordType: "Property",
    taxYear: 2020,
    account: 1909196,
    paid: true,
    amount: 427.11,
  },
  {
    ownerName: "Kaleena Lauridsen",
    recordType: "Property",
    taxYear: 2020,
    account: 1533794,
    paid: false,
    amount: 483.58,
  },
  {
    ownerName: "Shaylynn Lemon",
    recordType: "Property",
    taxYear: 2020,
    account: 1663650,
    paid: false,
    amount: 77.81,
  },
  {
    ownerName: "Tabbi Cloney",
    recordType: "Property",
    taxYear: 2020,
    account: 1824101,
    paid: false,
    amount: 189.47,
  },
  {
    ownerName: "Tan Stubbley",
    recordType: "Property",
    taxYear: 2020,
    account: 1771393,
    paid: false,
    amount: 138.14,
  },
  {
    ownerName: "Hettie Elderidge",
    recordType: "Property",
    taxYear: 2020,
    account: 1840584,
    paid: false,
    amount: 156.05,
  },
  {
    ownerName: "Devonne Rossetti",
    recordType: "Property",
    taxYear: 2020,
    account: 1248721,
    paid: false,
    amount: 137.82,
  },
  {
    ownerName: "Ax Pigford",
    recordType: "Property",
    taxYear: 2020,
    account: 1537562,
    paid: false,
    amount: 71.94,
  },
  {
    ownerName: "Adan Redd",
    recordType: "Property",
    taxYear: 2020,
    account: 1718515,
    paid: true,
    amount: 71.85,
  },
  {
    ownerName: "Cordie Davidi",
    recordType: "Property",
    taxYear: 2020,
    account: 1719307,
    paid: true,
    amount: 221.68,
  },
  {
    ownerName: "Erinna Thomkins",
    recordType: "Property",
    taxYear: 2020,
    account: 1720735,
    paid: false,
    amount: 52.63,
  },
  {
    ownerName: "Trudy Rollins",
    recordType: "Property",
    taxYear: 2020,
    account: 1293767,
    paid: true,
    amount: 400.7,
  },
  {
    ownerName: "Rowan Cattrell",
    recordType: "Property",
    taxYear: 2020,
    account: 1518361,
    paid: true,
    amount: 14.71,
  },
  {
    ownerName: "Michel Fountain",
    recordType: "Property",
    taxYear: 2020,
    account: 1570105,
    paid: true,
    amount: 48.46,
  },
  {
    ownerName: "Taffy Bignal",
    recordType: "Property",
    taxYear: 2020,
    account: 1348118,
    paid: true,
    amount: 391.44,
  },
  {
    ownerName: "Waite Master",
    recordType: "Property",
    taxYear: 2020,
    account: 1380014,
    paid: true,
    amount: 271.58,
  },
  {
    ownerName: "Rodge Pestor",
    recordType: "Property",
    taxYear: 2020,
    account: 1400166,
    paid: true,
    amount: 154.88,
  },
  {
    ownerName: "Lyssa Brundill",
    recordType: "Property",
    taxYear: 2020,
    account: 1382454,
    paid: false,
    amount: 167.69,
  },
  {
    ownerName: "Della Jerzycowski",
    recordType: "Property",
    taxYear: 2020,
    account: 1816393,
    paid: false,
    amount: 53.07,
  },
  {
    ownerName: "Devondra Kimmerling",
    recordType: "Property",
    taxYear: 2020,
    account: 1313615,
    paid: false,
    amount: 353.72,
  },
  {
    ownerName: "Cris Esser",
    recordType: "Property",
    taxYear: 2020,
    account: 1937369,
    paid: false,
    amount: 491.69,
  },
  {
    ownerName: "Mommy MacPake",
    recordType: "Property",
    taxYear: 2020,
    account: 1588356,
    paid: false,
    amount: 127.87,
  },
  {
    ownerName: "Ranee Boast",
    recordType: "Property",
    taxYear: 2020,
    account: 1601596,
    paid: true,
    amount: 194.65,
  },
  {
    ownerName: "Sissie Barkly",
    recordType: "Property",
    taxYear: 2020,
    account: 1223435,
    paid: true,
    amount: 119.97,
  },
  {
    ownerName: "Marla Forrest",
    recordType: "Property",
    taxYear: 2020,
    account: 1719901,
    paid: true,
    amount: 28.38,
  },
  {
    ownerName: "Linnet Crippen",
    recordType: "Property",
    taxYear: 2020,
    account: 1292606,
    paid: false,
    amount: 452.06,
  },
  {
    ownerName: "Ernie Pepis",
    recordType: "Property",
    taxYear: 2020,
    account: 1393956,
    paid: true,
    amount: 427.4,
  },
  {
    ownerName: "Lainey Klemt",
    recordType: "Property",
    taxYear: 2020,
    account: 1208103,
    paid: false,
    amount: 105.42,
  },
  {
    ownerName: "Jocko Liptrot",
    recordType: "Property",
    taxYear: 2020,
    account: 1257142,
    paid: true,
    amount: 298.62,
  },
  {
    ownerName: "Diannne Feeley",
    recordType: "Property",
    taxYear: 2020,
    account: 1239300,
    paid: true,
    amount: 348.2,
  },
  {
    ownerName: "Enrika Gye",
    recordType: "Property",
    taxYear: 2020,
    account: 1822371,
    paid: true,
    amount: 396.67,
  },
  {
    ownerName: "Valentine De Minico",
    recordType: "Property",
    taxYear: 2020,
    account: 1828915,
    paid: false,
    amount: 165.39,
  },
  {
    ownerName: "Chloe Fronsek",
    recordType: "Property",
    taxYear: 2020,
    account: 1669247,
    paid: false,
    amount: 30.87,
  },
  {
    ownerName: "Micki Faulds",
    recordType: "Property",
    taxYear: 2020,
    account: 1829880,
    paid: false,
    amount: 352.88,
  },
  {
    ownerName: "Mauricio Droogan",
    recordType: "Property",
    taxYear: 2020,
    account: 1250068,
    paid: false,
    amount: 499.53,
  },
  {
    ownerName: "Milicent Daleman",
    recordType: "Property",
    taxYear: 2020,
    account: 1925356,
    paid: false,
    amount: 56.32,
  },
  {
    ownerName: "Lexis Leverett",
    recordType: "Property",
    taxYear: 2020,
    account: 1792357,
    paid: true,
    amount: 121.54,
  },
  {
    ownerName: "Kerry Derr",
    recordType: "Property",
    taxYear: 2020,
    account: 1534605,
    paid: false,
    amount: 73.33,
  },
  {
    ownerName: "Davon Pessold",
    recordType: "Property",
    taxYear: 2020,
    account: 1303959,
    paid: true,
    amount: 82.34,
  },
  {
    ownerName: "Buckie Shevill",
    recordType: "Property",
    taxYear: 2020,
    account: 1929463,
    paid: true,
    amount: 471.12,
  },
  {
    ownerName: "Evvy Roth",
    recordType: "Property",
    taxYear: 2020,
    account: 1722280,
    paid: true,
    amount: 269.95,
  },
  {
    ownerName: "Christen Binner",
    recordType: "Property",
    taxYear: 2020,
    account: 1343410,
    paid: false,
    amount: 67.49,
  },
  {
    ownerName: "Shay Winspire",
    recordType: "Property",
    taxYear: 2020,
    account: 1886317,
    paid: false,
    amount: 182.26,
  },
  {
    ownerName: "Pandora Redgewell",
    recordType: "Property",
    taxYear: 2020,
    account: 1976254,
    paid: true,
    amount: 476.36,
  },
  {
    ownerName: "Jenica Sillis",
    recordType: "Property",
    taxYear: 2020,
    account: 1903996,
    paid: true,
    amount: 391.94,
  },
  {
    ownerName: "Gillie Clere",
    recordType: "Property",
    taxYear: 2020,
    account: 1345456,
    paid: false,
    amount: 272.14,
  },
  {
    ownerName: "Jereme Hammell",
    recordType: "Property",
    taxYear: 2020,
    account: 1911626,
    paid: false,
    amount: 95.67,
  },
  {
    ownerName: "Brandy Camblin",
    recordType: "Property",
    taxYear: 2020,
    account: 1499206,
    paid: true,
    amount: 342.44,
  },
  {
    ownerName: "Rica Alfuso",
    recordType: "Property",
    taxYear: 2020,
    account: 1760289,
    paid: false,
    amount: 215.38,
  },
  {
    ownerName: "Coop Symmons",
    recordType: "Property",
    taxYear: 2020,
    account: 1895291,
    paid: false,
    amount: 142.74,
  },
  {
    ownerName: "Leilah Hutchens",
    recordType: "Property",
    taxYear: 2020,
    account: 1924035,
    paid: true,
    amount: 67.15,
  },
  {
    ownerName: "Dyanne RudetaxYeard",
    recordType: "Property",
    taxYear: 2020,
    account: 1366678,
    paid: false,
    amount: 45.01,
  },
  {
    ownerName: "Arlana Stacy",
    recordType: "Property",
    taxYear: 2020,
    account: 1528165,
    paid: false,
    amount: 132.67,
  },
  {
    ownerName: "Donia Dickings",
    recordType: "Property",
    taxYear: 2020,
    account: 1656150,
    paid: true,
    amount: 499.18,
  },
  {
    ownerName: "Helyn LAbbet",
    recordType: "Property",
    taxYear: 2020,
    account: 1773076,
    paid: false,
    amount: 485.15,
  },
  {
    ownerName: "Zachary Moreinu",
    recordType: "Property",
    taxYear: 2020,
    account: 1560883,
    paid: false,
    amount: 434.34,
  },
  {
    ownerName: "Fons Heape",
    recordType: "Property",
    taxYear: 2020,
    account: 1739210,
    paid: false,
    amount: 487.28,
  },
  {
    ownerName: "Kata Piesing",
    recordType: "Property",
    taxYear: 2020,
    account: 1892960,
    paid: false,
    amount: 411.1,
  },
  {
    ownerName: "Rusty Bellany",
    recordType: "Property",
    taxYear: 2020,
    account: 1983448,
    paid: false,
    amount: 111.42,
  },
  {
    ownerName: "Garret Grouer",
    recordType: "Property",
    taxYear: 2020,
    account: 1526966,
    paid: false,
    amount: 108.57,
  },
  {
    ownerName: "Bartlet Swinburne",
    recordType: "Property",
    taxYear: 2020,
    account: 1861128,
    paid: true,
    amount: 268.19,
  },
  {
    ownerName: "Shaughn Nisius",
    recordType: "Property",
    taxYear: 2020,
    account: 1372868,
    paid: false,
    amount: 177.09,
  },
  {
    ownerName: "Griz Antonat",
    recordType: "Property",
    taxYear: 2020,
    account: 1654853,
    paid: false,
    amount: 451.85,
  },
  {
    ownerName: "Devlin Hourihan",
    recordType: "Property",
    taxYear: 2020,
    account: 1317082,
    paid: false,
    amount: 157.55,
  },
  {
    ownerName: "Danita Aldhouse",
    recordType: "Property",
    taxYear: 2020,
    account: 1502678,
    paid: true,
    amount: 148.86,
  },
  {
    ownerName: "Garey Hallgalley",
    recordType: "Property",
    taxYear: 2020,
    account: 1431704,
    paid: true,
    amount: 147.1,
  },
  {
    ownerName: "Lew Bauckham",
    recordType: "Property",
    taxYear: 2020,
    account: 1608851,
    paid: true,
    amount: 401.25,
  },
  {
    ownerName: "Lombard Jirak",
    recordType: "Property",
    taxYear: 2020,
    account: 1784538,
    paid: true,
    amount: 245.94,
  },
  {
    ownerName: "Siffre Treherne",
    recordType: "Property",
    taxYear: 2020,
    account: 1677634,
    paid: true,
    amount: 358.32,
  },
  {
    ownerName: "Nicoline Darmody",
    recordType: "Property",
    taxYear: 2020,
    account: 1643748,
    paid: false,
    amount: 34.78,
  },
  {
    ownerName: "Betty Syrad",
    recordType: "Property",
    taxYear: 2020,
    account: 1875098,
    paid: true,
    amount: 193.66,
  },
  {
    ownerName: "Thaxter Rigler",
    recordType: "Property",
    taxYear: 2020,
    account: 1376751,
    paid: true,
    amount: 196.8,
  },
  {
    ownerName: "Rutter Colrein",
    recordType: "Property",
    taxYear: 2020,
    account: 1547360,
    paid: false,
    amount: 202.45,
  },
  {
    ownerName: "Hyatt Springer",
    recordType: "Property",
    taxYear: 2020,
    account: 1744648,
    paid: false,
    amount: 266.62,
  },
  {
    ownerName: "Antonina Livesley",
    recordType: "Property",
    taxYear: 2020,
    account: 1360708,
    paid: false,
    amount: 389.25,
  },
  {
    ownerName: "Ardath Pellett",
    recordType: "Property",
    taxYear: 2020,
    account: 1638275,
    paid: true,
    amount: 344.74,
  },
  {
    ownerName: "Alidia Kither",
    recordType: "Property",
    taxYear: 2020,
    account: 1896277,
    paid: true,
    amount: 224.18,
  },
  {
    ownerName: "Geneva Dartnell",
    recordType: "Property",
    taxYear: 2020,
    account: 1610432,
    paid: false,
    amount: 109.38,
  },
  {
    ownerName: "Lida Ellit",
    recordType: "Property",
    taxYear: 2020,
    account: 1875459,
    paid: false,
    amount: 463.9,
  },
  {
    ownerName: "Auberta McGeechan",
    recordType: "Property",
    taxYear: 2020,
    account: 1427269,
    paid: false,
    amount: 6.39,
  },
  {
    ownerName: "Catarina Favela",
    recordType: "Property",
    taxYear: 2020,
    account: 1456627,
    paid: true,
    amount: 41.43,
  },
  {
    ownerName: "Ruddy Arboin",
    recordType: "Property",
    taxYear: 2020,
    account: 1953925,
    paid: false,
    amount: 266.13,
  },
  {
    ownerName: "Claudell Creddon",
    recordType: "Property",
    taxYear: 2020,
    account: 1848457,
    paid: true,
    amount: 146.89,
  },
  {
    ownerName: "Rollin Alford",
    recordType: "Property",
    taxYear: 2020,
    account: 1596691,
    paid: false,
    amount: 118.3,
  },
  {
    ownerName: "Katherina Batting",
    recordType: "Property",
    taxYear: 2020,
    account: 1242963,
    paid: false,
    amount: 170.93,
  },
  {
    ownerName: "Eve Pickrell",
    recordType: "Property",
    taxYear: 2020,
    account: 1526166,
    paid: true,
    amount: 275.85,
  },
  {
    ownerName: "Yetta Nowill",
    recordType: "Property",
    taxYear: 2020,
    account: 1875306,
    paid: true,
    amount: 168.48,
  },
  {
    ownerName: "Carson McArthur",
    recordType: "Property",
    taxYear: 2020,
    account: 1385200,
    paid: true,
    amount: 370.25,
  },
  {
    ownerName: "Sheelah Tysack",
    recordType: "Property",
    taxYear: 2020,
    account: 1883519,
    paid: true,
    amount: 210.87,
  },
  {
    ownerName: "Shirline Binney",
    recordType: "Property",
    taxYear: 2020,
    account: 1976243,
    paid: true,
    amount: 265.69,
  },
  {
    ownerName: "Page Vowels",
    recordType: "Property",
    taxYear: 2020,
    account: 1226595,
    paid: true,
    amount: 61.21,
  },
  {
    ownerName: "Quintina Armes",
    recordType: "Property",
    taxYear: 2020,
    account: 1610632,
    paid: true,
    amount: 34.57,
  },
  {
    ownerName: "Theodore Knifton",
    recordType: "Property",
    taxYear: 2020,
    account: 1814925,
    paid: false,
    amount: 120.31,
  },
  {
    ownerName: "Virgie Heathwood",
    recordType: "Property",
    taxYear: 2020,
    account: 1360628,
    paid: true,
    amount: 369.68,
  },
  {
    ownerName: "Lea Polley",
    recordType: "Property",
    taxYear: 2020,
    account: 1988526,
    paid: true,
    amount: 243.41,
  },
  {
    ownerName: "Zacharia Arghent",
    recordType: "Property",
    taxYear: 2020,
    account: 1828953,
    paid: false,
    amount: 386.84,
  },
  {
    ownerName: "Stepha Pawelec",
    recordType: "Property",
    taxYear: 2020,
    account: 1463772,
    paid: false,
    amount: 404.53,
  },
  {
    ownerName: "Felita Lodemann",
    recordType: "Property",
    taxYear: 2020,
    account: 1741389,
    paid: false,
    amount: 144.38,
  },
  {
    ownerName: "Loella Napier",
    recordType: "Property",
    taxYear: 2020,
    account: 1490555,
    paid: false,
    amount: 278.86,
  },
  {
    ownerName: "Ibbie Rebanks",
    recordType: "Property",
    taxYear: 2020,
    account: 1411417,
    paid: false,
    amount: 66.55,
  },
  {
    ownerName: "Ebonee Joselevitz",
    recordType: "Property",
    taxYear: 2020,
    account: 1949198,
    paid: false,
    amount: 444.71,
  },
  {
    ownerName: "June Gold",
    recordType: "Property",
    taxYear: 2020,
    account: 1651549,
    paid: false,
    amount: 255.44,
  },
  {
    ownerName: "Grant Amthor",
    recordType: "Property",
    taxYear: 2020,
    account: 1257363,
    paid: true,
    amount: 417.63,
  },
  {
    ownerName: "Willey Kilian",
    recordType: "Property",
    taxYear: 2020,
    account: 1820942,
    paid: false,
    amount: 458.66,
  },
  {
    ownerName: "Dorotea Cruikshanks",
    recordType: "Property",
    taxYear: 2020,
    account: 1316985,
    paid: true,
    amount: 225.51,
  },
  {
    ownerName: "Marthena Macklin",
    recordType: "Property",
    taxYear: 2020,
    account: 1237375,
    paid: false,
    amount: 236.6,
  },
  {
    ownerName: "Regan Clulee",
    recordType: "Property",
    taxYear: 2020,
    account: 1543283,
    paid: false,
    amount: 398.48,
  },
  {
    ownerName: "Wally Strickler",
    recordType: "Property",
    taxYear: 2020,
    account: 1893779,
    paid: true,
    amount: 174.07,
  },
  {
    ownerName: "Halsey Olivari",
    recordType: "Property",
    taxYear: 2020,
    account: 1966397,
    paid: false,
    amount: 146.44,
  },
  {
    ownerName: "Clementia Gethins",
    recordType: "Property",
    taxYear: 2020,
    account: 1790091,
    paid: true,
    amount: 85.09,
  },
  {
    ownerName: "Dulcie Diem",
    recordType: "Property",
    taxYear: 2020,
    account: 1661163,
    paid: true,
    amount: 99.11,
  },
  {
    ownerName: "Alyson Plessing",
    recordType: "Property",
    taxYear: 2020,
    account: 1725409,
    paid: false,
    amount: 496.69,
  },
  {
    ownerName: "Ivar Livesley",
    recordType: "Property",
    taxYear: 2020,
    account: 1460723,
    paid: false,
    amount: 488.74,
  },
  {
    ownerName: "Ebeneser Tegeller",
    recordType: "Property",
    taxYear: 2020,
    account: 1428627,
    paid: true,
    amount: 489.99,
  },
  {
    ownerName: "Roderigo Fewless",
    recordType: "Property",
    taxYear: 2020,
    account: 1433243,
    paid: true,
    amount: 285.74,
  },
  {
    ownerName: "Raleigh Wrightem",
    recordType: "Property",
    taxYear: 2020,
    account: 1394493,
    paid: true,
    amount: 31.9,
  },
  {
    ownerName: "Malinda Leete",
    recordType: "Property",
    taxYear: 2020,
    account: 1677909,
    paid: true,
    amount: 496.85,
  },
  {
    ownerName: "Bettye Matejovsky",
    recordType: "Property",
    taxYear: 2020,
    account: 1951291,
    paid: true,
    amount: 183.96,
  },
  {
    ownerName: "Deny Hamlet",
    recordType: "Property",
    taxYear: 2020,
    account: 1955755,
    paid: false,
    amount: 304.47,
  },
  {
    ownerName: "Louie Knighton",
    recordType: "Property",
    taxYear: 2020,
    account: 1367539,
    paid: false,
    amount: 1.86,
  },
  {
    ownerName: "Olympe Roslen",
    recordType: "Property",
    taxYear: 2020,
    account: 1856383,
    paid: false,
    amount: 405.79,
  },
  {
    ownerName: "Ham Consterdine",
    recordType: "Property",
    taxYear: 2020,
    account: 1995877,
    paid: false,
    amount: 323.06,
  },
  {
    ownerName: "Jodi Lade",
    recordType: "Property",
    taxYear: 2020,
    account: 1978531,
    paid: false,
    amount: 70.91,
  },
  {
    ownerName: "Larisa Sommerly",
    recordType: "Property",
    taxYear: 2020,
    account: 1481826,
    paid: true,
    amount: 457.18,
  },
  {
    ownerName: "Rutter Huburn",
    recordType: "Property",
    taxYear: 2020,
    account: 1260785,
    paid: false,
    amount: 309.96,
  },
  {
    ownerName: "Donovan Biasini",
    recordType: "Property",
    taxYear: 2020,
    account: 1922105,
    paid: true,
    amount: 137.65,
  },
  {
    ownerName: "Patton Jakubski",
    recordType: "Property",
    taxYear: 2020,
    account: 1885452,
    paid: true,
    amount: 273.03,
  },
  {
    ownerName: "Theodor Messitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1678217,
    paid: false,
    amount: 15.5,
  },
  {
    ownerName: "Harriot Rableau",
    recordType: "Property",
    taxYear: 2020,
    account: 1356031,
    paid: false,
    amount: 376.39,
  },
  {
    ownerName: "Gianna Trussler",
    recordType: "Property",
    taxYear: 2020,
    account: 1706797,
    paid: false,
    amount: 243.3,
  },
  {
    ownerName: "Clarette Fayne",
    recordType: "Property",
    taxYear: 2020,
    account: 1858103,
    paid: false,
    amount: 123.13,
  },
  {
    ownerName: "Collete Utterson",
    recordType: "Property",
    taxYear: 2020,
    account: 1294035,
    paid: true,
    amount: 185.36,
  },
  {
    ownerName: "Abigail Leftly",
    recordType: "Property",
    taxYear: 2020,
    account: 1910636,
    paid: false,
    amount: 354.52,
  },
  {
    ownerName: "Robbie Walbrook",
    recordType: "Property",
    taxYear: 2020,
    account: 1926918,
    paid: false,
    amount: 491.22,
  },
  {
    ownerName: "Ulrich Waison",
    recordType: "Property",
    taxYear: 2020,
    account: 1375647,
    paid: true,
    amount: 343.66,
  },
  {
    ownerName: "Pepito Craisford",
    recordType: "Property",
    taxYear: 2020,
    account: 1935403,
    paid: false,
    amount: 224.82,
  },
  {
    ownerName: "Del Tansley",
    recordType: "Property",
    taxYear: 2020,
    account: 1581163,
    paid: true,
    amount: 249.29,
  },
  {
    ownerName: "Roze Radband",
    recordType: "Property",
    taxYear: 2020,
    account: 1974800,
    paid: false,
    amount: 428.28,
  },
  {
    ownerName: "Tyrus Rugg",
    recordType: "Property",
    taxYear: 2020,
    account: 1509288,
    paid: false,
    amount: 24.86,
  },
  {
    ownerName: "Randi Burnhard",
    recordType: "Property",
    taxYear: 2020,
    account: 1309575,
    paid: false,
    amount: 188.72,
  },
  {
    ownerName: "Lyndel Sturr",
    recordType: "Property",
    taxYear: 2020,
    account: 1367623,
    paid: true,
    amount: 389.71,
  },
  {
    ownerName: "Dianne Breslane",
    recordType: "Property",
    taxYear: 2020,
    account: 1753384,
    paid: true,
    amount: 191.78,
  },
  {
    ownerName: "Lucho Turbitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1350710,
    paid: false,
    amount: 64.77,
  },
  {
    ownerName: "Kinny Colthard",
    recordType: "Property",
    taxYear: 2020,
    account: 1480622,
    paid: false,
    amount: 175.95,
  },
  {
    ownerName: "Charlene Crayton",
    recordType: "Property",
    taxYear: 2020,
    account: 1710304,
    paid: true,
    amount: 129.49,
  },
  {
    ownerName: "Axel Danniell",
    recordType: "Property",
    taxYear: 2020,
    account: 1463971,
    paid: true,
    amount: 304.25,
  },
  {
    ownerName: "Eve Clemmow",
    recordType: "Property",
    taxYear: 2020,
    account: 1439889,
    paid: true,
    amount: 57.89,
  },
  {
    ownerName: "Merwyn Purry",
    recordType: "Property",
    taxYear: 2020,
    account: 1516454,
    paid: true,
    amount: 301.2,
  },
  {
    ownerName: "Aeriela Grimm",
    recordType: "Property",
    taxYear: 2020,
    account: 1769824,
    paid: false,
    amount: 493.0,
  },
  {
    ownerName: "Nance Weatherburn",
    recordType: "Property",
    taxYear: 2020,
    account: 1653069,
    paid: true,
    amount: 191.9,
  },
  {
    ownerName: "Thekla Lennox",
    recordType: "Property",
    taxYear: 2020,
    account: 1690600,
    paid: false,
    amount: 207.14,
  },
  {
    ownerName: "Igor Ambrose",
    recordType: "Property",
    taxYear: 2020,
    account: 1464241,
    paid: false,
    amount: 165.04,
  },
  {
    ownerName: "Buiron Simmen",
    recordType: "Property",
    taxYear: 2020,
    account: 1335208,
    paid: false,
    amount: 484.84,
  },
  {
    ownerName: "Elysee Brunger",
    recordType: "Property",
    taxYear: 2020,
    account: 1861011,
    paid: false,
    amount: 374.44,
  },
  {
    ownerName: "Jeniffer De Blasi",
    recordType: "Property",
    taxYear: 2020,
    account: 1997566,
    paid: true,
    amount: 333.87,
  },
  {
    ownerName: "Brok Callendar",
    recordType: "Property",
    taxYear: 2020,
    account: 1279716,
    paid: false,
    amount: 435.9,
  },
  {
    ownerName: "Urban Moulsdale",
    recordType: "Property",
    taxYear: 2020,
    account: 1933635,
    paid: true,
    amount: 202.45,
  },
  {
    ownerName: "Cristobal Nerheny",
    recordType: "Property",
    taxYear: 2020,
    account: 1786444,
    paid: false,
    amount: 434.7,
  },
  {
    ownerName: "Doralin Mechan",
    recordType: "Property",
    taxYear: 2020,
    account: 1828294,
    paid: false,
    amount: 359.09,
  },
  {
    ownerName: "Andriana Capitano",
    recordType: "Property",
    taxYear: 2020,
    account: 1903049,
    paid: false,
    amount: 274.11,
  },
  {
    ownerName: "Francois Merredy",
    recordType: "Property",
    taxYear: 2020,
    account: 1765222,
    paid: true,
    amount: 254.39,
  },
  {
    ownerName: "Nerty Sicely",
    recordType: "Property",
    taxYear: 2020,
    account: 1261298,
    paid: true,
    amount: 423.14,
  },
  {
    ownerName: "Trent Drewson",
    recordType: "Property",
    taxYear: 2020,
    account: 1741804,
    paid: false,
    amount: 156.57,
  },
  {
    ownerName: "Melly Bartle",
    recordType: "Property",
    taxYear: 2020,
    account: 1780246,
    paid: true,
    amount: 97.12,
  },
  {
    ownerName: "Jackie Brute",
    recordType: "Property",
    taxYear: 2020,
    account: 1436291,
    paid: false,
    amount: 290.36,
  },
  {
    ownerName: "Lidia Rogger",
    recordType: "Property",
    taxYear: 2020,
    account: 1522714,
    paid: true,
    amount: 34.18,
  },
  {
    ownerName: "Beatrix Bernath",
    recordType: "Property",
    taxYear: 2020,
    account: 1546632,
    paid: true,
    amount: 130.32,
  },
  {
    ownerName: "Leupold Pratley",
    recordType: "Property",
    taxYear: 2020,
    account: 1224376,
    paid: true,
    amount: 15.73,
  },
  {
    ownerName: "Sarah Averies",
    recordType: "Property",
    taxYear: 2020,
    account: 1659333,
    paid: false,
    amount: 72.88,
  },
  {
    ownerName: "Keen Swaden",
    recordType: "Property",
    taxYear: 2020,
    account: 1381868,
    paid: true,
    amount: 371.7,
  },
  {
    ownerName: "Goldie Potts",
    recordType: "Property",
    taxYear: 2020,
    account: 1829595,
    paid: true,
    amount: 35.93,
  },
  {
    ownerName: "Eli O'Lagen",
    recordType: "Property",
    taxYear: 2020,
    account: 1671061,
    paid: false,
    amount: 353.57,
  },
  {
    ownerName: "Garry Lown",
    recordType: "Property",
    taxYear: 2020,
    account: 1566859,
    paid: false,
    amount: 46.58,
  },
  {
    ownerName: "Teador Caddock",
    recordType: "Property",
    taxYear: 2020,
    account: 1323101,
    paid: false,
    amount: 89.24,
  },
  {
    ownerName: "Sissie Baigrie",
    recordType: "Property",
    taxYear: 2020,
    account: 1579202,
    paid: true,
    amount: 271.76,
  },
  {
    ownerName: "Juana Hinckesman",
    recordType: "Property",
    taxYear: 2020,
    account: 1444460,
    paid: true,
    amount: 199.32,
  },
  {
    ownerName: "Nathaniel Northin",
    recordType: "Property",
    taxYear: 2020,
    account: 1952647,
    paid: true,
    amount: 138.78,
  },
  {
    ownerName: "Woodrow Ianinotti",
    recordType: "Property",
    taxYear: 2020,
    account: 1498283,
    paid: true,
    amount: 190.32,
  },
  {
    ownerName: "Audrey Melan",
    recordType: "Property",
    taxYear: 2020,
    account: 1343734,
    paid: false,
    amount: 33.25,
  },
  {
    ownerName: "Joana Isles",
    recordType: "Property",
    taxYear: 2020,
    account: 1451273,
    paid: true,
    amount: 206.35,
  },
  {
    ownerName: "Fabio Sodeau",
    recordType: "Property",
    taxYear: 2020,
    account: 1945151,
    paid: false,
    amount: 333.9,
  },
  {
    ownerName: "Rivi Gypson",
    recordType: "Property",
    taxYear: 2020,
    account: 1860272,
    paid: true,
    amount: 110.51,
  },
  {
    ownerName: "Valaree Diable",
    recordType: "Property",
    taxYear: 2020,
    account: 1249556,
    paid: false,
    amount: 341.18,
  },
  {
    ownerName: "Emili Wellman",
    recordType: "Property",
    taxYear: 2020,
    account: 1231288,
    paid: true,
    amount: 321.24,
  },
  {
    ownerName: "Jeanette Schroeder",
    recordType: "Property",
    taxYear: 2020,
    account: 1497522,
    paid: true,
    amount: 316.22,
  },
  {
    ownerName: "Perrine Doree",
    recordType: "Property",
    taxYear: 2020,
    account: 1575854,
    paid: false,
    amount: 222.9,
  },
  {
    ownerName: "Tyrone Wraith",
    recordType: "Property",
    taxYear: 2020,
    account: 1368708,
    paid: false,
    amount: 93.66,
  },
  {
    ownerName: "Cass Grinston",
    recordType: "Property",
    taxYear: 2020,
    account: 1875612,
    paid: true,
    amount: 274.06,
  },
  {
    ownerName: "Franky Bruton",
    recordType: "Property",
    taxYear: 2020,
    account: 1271270,
    paid: false,
    amount: 435.67,
  },
  {
    ownerName: "Orsola Pulster",
    recordType: "Property",
    taxYear: 2020,
    account: 1654117,
    paid: true,
    amount: 338.49,
  },
  {
    ownerName: "Raven Liepina",
    recordType: "Property",
    taxYear: 2020,
    account: 1995125,
    paid: false,
    amount: 331.37,
  },
  {
    ownerName: "Claudette Slite",
    recordType: "Property",
    taxYear: 2020,
    account: 1381019,
    paid: true,
    amount: 130.56,
  },
  {
    ownerName: "Kara-lynn Gratland",
    recordType: "Property",
    taxYear: 2020,
    account: 1343296,
    paid: false,
    amount: 127.77,
  },
  {
    ownerName: "Halli Houltham",
    recordType: "Property",
    taxYear: 2020,
    account: 1339503,
    paid: false,
    amount: 12.11,
  },
  {
    ownerName: "Adriaens Sibbit",
    recordType: "Property",
    taxYear: 2020,
    account: 1744491,
    paid: true,
    amount: 72.11,
  },
  {
    ownerName: "Cecelia McCaskill",
    recordType: "Property",
    taxYear: 2020,
    account: 1925895,
    paid: true,
    amount: 225.85,
  },
  {
    ownerName: "Broddie Northridge",
    recordType: "Property",
    taxYear: 2020,
    account: 1278057,
    paid: false,
    amount: 472.71,
  },
  {
    ownerName: "Mikol Bloschke",
    recordType: "Property",
    taxYear: 2020,
    account: 1345315,
    paid: true,
    amount: 234.98,
  },
  {
    ownerName: "Ronica Morley",
    recordType: "Property",
    taxYear: 2020,
    account: 1352281,
    paid: false,
    amount: 36.27,
  },
  {
    ownerName: "Maribel Beavors",
    recordType: "Property",
    taxYear: 2020,
    account: 1772742,
    paid: false,
    amount: 254.13,
  },
  {
    ownerName: "Trstram Perrone",
    recordType: "Property",
    taxYear: 2020,
    account: 1235669,
    paid: false,
    amount: 308.83,
  },
  {
    ownerName: "Clarice Houson",
    recordType: "Property",
    taxYear: 2020,
    account: 1329327,
    paid: true,
    amount: 434.96,
  },
  {
    ownerName: "Loydie Esome",
    recordType: "Property",
    taxYear: 2020,
    account: 1352483,
    paid: true,
    amount: 303.45,
  },
  {
    ownerName: "Courtney Durbyn",
    recordType: "Property",
    taxYear: 2020,
    account: 1862967,
    paid: false,
    amount: 147.04,
  },
  {
    ownerName: "Jennilee Bortoletti",
    recordType: "Property",
    taxYear: 2020,
    account: 1257507,
    paid: false,
    amount: 305.46,
  },
  {
    ownerName: "Marion Leteurtre",
    recordType: "Property",
    taxYear: 2020,
    account: 1288488,
    paid: true,
    amount: 398.76,
  },
  {
    ownerName: "Hamlin Lortzing",
    recordType: "Property",
    taxYear: 2020,
    account: 1995470,
    paid: true,
    amount: 14.37,
  },
  {
    ownerName: "Devon Ayrs",
    recordType: "Property",
    taxYear: 2020,
    account: 1849343,
    paid: true,
    amount: 192.17,
  },
  {
    ownerName: "Rollins Hulme",
    recordType: "Property",
    taxYear: 2020,
    account: 1799117,
    paid: true,
    amount: 124.59,
  },
  {
    ownerName: "Steffi Rival",
    recordType: "Property",
    taxYear: 2020,
    account: 1500438,
    paid: false,
    amount: 495.41,
  },
  {
    ownerName: "Jim Treece",
    recordType: "Property",
    taxYear: 2020,
    account: 1226549,
    paid: false,
    amount: 249.52,
  },
  {
    ownerName: "Ardys Munning",
    recordType: "Property",
    taxYear: 2020,
    account: 1629069,
    paid: true,
    amount: 123.55,
  },
  {
    ownerName: "Marillin Bernhard",
    recordType: "Property",
    taxYear: 2020,
    account: 1708306,
    paid: false,
    amount: 190.54,
  },
  {
    ownerName: "Sibel McNelis",
    recordType: "Property",
    taxYear: 2020,
    account: 1278835,
    paid: false,
    amount: 52.12,
  },
  {
    ownerName: "Teddie Kippax",
    recordType: "Property",
    taxYear: 2020,
    account: 1389859,
    paid: true,
    amount: 367.56,
  },
  {
    ownerName: "Brena Mariyushkin",
    recordType: "Property",
    taxYear: 2020,
    account: 1343640,
    paid: true,
    amount: 97.89,
  },
  {
    ownerName: "Conni Game",
    recordType: "Property",
    taxYear: 2020,
    account: 1814597,
    paid: true,
    amount: 311.0,
  },
  {
    ownerName: "Osbert Vedeniktov",
    recordType: "Property",
    taxYear: 2020,
    account: 1461321,
    paid: false,
    amount: 27.58,
  },
  {
    ownerName: "Gennie Shallow",
    recordType: "Property",
    taxYear: 2020,
    account: 1793925,
    paid: true,
    amount: 249.99,
  },
  {
    ownerName: "Sheridan Dullard",
    recordType: "Property",
    taxYear: 2020,
    account: 1702057,
    paid: true,
    amount: 337.5,
  },
  {
    ownerName: "Shurlocke Spiller",
    recordType: "Property",
    taxYear: 2020,
    account: 1406753,
    paid: false,
    amount: 262.39,
  },
  {
    ownerName: "Dorise Toolin",
    recordType: "Property",
    taxYear: 2020,
    account: 1252971,
    paid: false,
    amount: 27.5,
  },
  {
    ownerName: "Zedekiah Seviour",
    recordType: "Property",
    taxYear: 2020,
    account: 1333096,
    paid: true,
    amount: 36.17,
  },
  {
    ownerName: "Birdie Verden",
    recordType: "Property",
    taxYear: 2020,
    account: 1207276,
    paid: true,
    amount: 172.59,
  },
  {
    ownerName: "Hunfredo Yendle",
    recordType: "Property",
    taxYear: 2020,
    account: 1679492,
    paid: false,
    amount: 413.94,
  },
  {
    ownerName: "Dolorita Hendin",
    recordType: "Property",
    taxYear: 2020,
    account: 1889750,
    paid: true,
    amount: 77.41,
  },
  {
    ownerName: "Perle Jeppe",
    recordType: "Property",
    taxYear: 2020,
    account: 1628391,
    paid: true,
    amount: 273.67,
  },
  {
    ownerName: "Greg Seamarke",
    recordType: "Property",
    taxYear: 2020,
    account: 1354022,
    paid: true,
    amount: 118.82,
  },
  {
    ownerName: "Catharina Cadding",
    recordType: "Property",
    taxYear: 2020,
    account: 1231603,
    paid: false,
    amount: 377.35,
  },
  {
    ownerName: "Conrad Limbrick",
    recordType: "Property",
    taxYear: 2020,
    account: 1732276,
    paid: true,
    amount: 101.2,
  },
  {
    ownerName: "Brad Balsillie",
    recordType: "Property",
    taxYear: 2020,
    account: 1467719,
    paid: false,
    amount: 39.7,
  },
  {
    ownerName: "Amye Dreschler",
    recordType: "Property",
    taxYear: 2020,
    account: 1674247,
    paid: false,
    amount: 20.28,
  },
  {
    ownerName: "Timoteo Simyson",
    recordType: "Property",
    taxYear: 2020,
    account: 1622302,
    paid: false,
    amount: 161.81,
  },
  {
    ownerName: "Basia Guion",
    recordType: "Property",
    taxYear: 2020,
    account: 1346708,
    paid: false,
    amount: 405.71,
  },
  {
    ownerName: "Curry Beamont",
    recordType: "Property",
    taxYear: 2020,
    account: 1733125,
    paid: true,
    amount: 27.46,
  },
  {
    ownerName: "Ranice Cocksedge",
    recordType: "Property",
    taxYear: 2020,
    account: 1213074,
    paid: true,
    amount: 124.3,
  },
  {
    ownerName: "Theresita Birdwhistell",
    recordType: "Property",
    taxYear: 2020,
    account: 1737232,
    paid: false,
    amount: 44.16,
  },
  {
    ownerName: "Elva MacShirrie",
    recordType: "Property",
    taxYear: 2020,
    account: 1251299,
    paid: false,
    amount: 490.49,
  },
  {
    ownerName: "Link Leopard",
    recordType: "Property",
    taxYear: 2020,
    account: 1388795,
    paid: true,
    amount: 239.86,
  },
  {
    ownerName: "Tawsha Merman",
    recordType: "Property",
    taxYear: 2020,
    account: 1272835,
    paid: false,
    amount: 148.23,
  },
  {
    ownerName: "Mordecai Larmett",
    recordType: "Property",
    taxYear: 2020,
    account: 1623759,
    paid: false,
    amount: 208.85,
  },
  {
    ownerName: "Bernadine Stairmand",
    recordType: "Property",
    taxYear: 2020,
    account: 1385565,
    paid: false,
    amount: 270.11,
  },
  {
    ownerName: "Dunstan Fink",
    recordType: "Property",
    taxYear: 2020,
    account: 1953204,
    paid: false,
    amount: 241.67,
  },
  {
    ownerName: "Eolanda Gulleford",
    recordType: "Property",
    taxYear: 2020,
    account: 1453274,
    paid: true,
    amount: 377.17,
  },
  {
    ownerName: "Bord Tompion",
    recordType: "Property",
    taxYear: 2020,
    account: 1338583,
    paid: false,
    amount: 243.11,
  },
  {
    ownerName: "Millard Ferro",
    recordType: "Property",
    taxYear: 2020,
    account: 1280782,
    paid: true,
    amount: 205.68,
  },
  {
    ownerName: "Aigneis Hosburn",
    recordType: "Property",
    taxYear: 2020,
    account: 1986000,
    paid: true,
    amount: 37.69,
  },
  {
    ownerName: "Miran Bellay",
    recordType: "Property",
    taxYear: 2020,
    account: 1773654,
    paid: true,
    amount: 449.4,
  },
  {
    ownerName: "Cissiee Curbishley",
    recordType: "Property",
    taxYear: 2020,
    account: 1214314,
    paid: true,
    amount: 190.97,
  },
  {
    ownerName: "Pamella Stratiff",
    recordType: "Property",
    taxYear: 2020,
    account: 1246358,
    paid: true,
    amount: 111.3,
  },
  {
    ownerName: "Prissie Proske",
    recordType: "Property",
    taxYear: 2020,
    account: 1402196,
    paid: false,
    amount: 42.54,
  },
  {
    ownerName: "Reinaldos Curnick",
    recordType: "Property",
    taxYear: 2020,
    account: 1582565,
    paid: false,
    amount: 405.73,
  },
  {
    ownerName: "Antoinette Seger",
    recordType: "Property",
    taxYear: 2020,
    account: 1281153,
    paid: true,
    amount: 90.71,
  },
  {
    ownerName: "Wakefield Steagall",
    recordType: "Property",
    taxYear: 2020,
    account: 1264979,
    paid: false,
    amount: 204.31,
  },
  {
    ownerName: "Jacqueline Pover",
    recordType: "Property",
    taxYear: 2020,
    account: 1260234,
    paid: true,
    amount: 261.97,
  },
  {
    ownerName: "Evania Male",
    recordType: "Property",
    taxYear: 2020,
    account: 1446629,
    paid: true,
    amount: 73.13,
  },
  {
    ownerName: "Branden Waumsley",
    recordType: "Property",
    taxYear: 2020,
    account: 1677048,
    paid: false,
    amount: 264.37,
  },
  {
    ownerName: "Rivy Bangs",
    recordType: "Property",
    taxYear: 2020,
    account: 1769663,
    paid: true,
    amount: 108.54,
  },
  {
    ownerName: "Rosanne Lowth",
    recordType: "Property",
    taxYear: 2020,
    account: 1871107,
    paid: false,
    amount: 384.5,
  },
  {
    ownerName: "Joyous Armsby",
    recordType: "Property",
    taxYear: 2020,
    account: 1697678,
    paid: false,
    amount: 233.03,
  },
  {
    ownerName: "Donalt Leas",
    recordType: "Property",
    taxYear: 2020,
    account: 1914967,
    paid: false,
    amount: 372.33,
  },
  {
    ownerName: "Anatola Ahlf",
    recordType: "Property",
    taxYear: 2020,
    account: 1828718,
    paid: false,
    amount: 316.0,
  },
  {
    ownerName: "Jamie Rushmer",
    recordType: "Property",
    taxYear: 2020,
    account: 1923318,
    paid: true,
    amount: 410.6,
  },
  {
    ownerName: "Dorotea Huntley",
    recordType: "Property",
    taxYear: 2020,
    account: 1283298,
    paid: false,
    amount: 342.13,
  },
  {
    ownerName: "Dasi Godley",
    recordType: "Property",
    taxYear: 2020,
    account: 1767606,
    paid: true,
    amount: 361.48,
  },
  {
    ownerName: "Brittany Ingley",
    recordType: "Property",
    taxYear: 2020,
    account: 1546793,
    paid: true,
    amount: 362.0,
  },
  {
    ownerName: "Mahalia Tiernan",
    recordType: "Property",
    taxYear: 2020,
    account: 1775285,
    paid: true,
    amount: 131.74,
  },
  {
    ownerName: "Frasquito Addenbrooke",
    recordType: "Property",
    taxYear: 2020,
    account: 1594180,
    paid: true,
    amount: 1.5,
  },
  {
    ownerName: "Jodie Koenen",
    recordType: "Property",
    taxYear: 2020,
    account: 1282856,
    paid: true,
    amount: 122.55,
  },
  {
    ownerName: "Eben Eskrigge",
    recordType: "Property",
    taxYear: 2020,
    account: 1902873,
    paid: false,
    amount: 471.46,
  },
  {
    ownerName: "Faith Lushey",
    recordType: "Property",
    taxYear: 2020,
    account: 1981914,
    paid: false,
    amount: 64.41,
  },
  {
    ownerName: "Iago Jacqueminot",
    recordType: "Property",
    taxYear: 2020,
    account: 1859302,
    paid: true,
    amount: 223.59,
  },
  {
    ownerName: "Leelah Jeanel",
    recordType: "Property",
    taxYear: 2020,
    account: 1393089,
    paid: true,
    amount: 287.36,
  },
  {
    ownerName: "Janel McKinnon",
    recordType: "Property",
    taxYear: 2020,
    account: 1977318,
    paid: true,
    amount: 31.5,
  },
  {
    ownerName: "Maddy Josuweit",
    recordType: "Property",
    taxYear: 2020,
    account: 1486664,
    paid: true,
    amount: 249.5,
  },
  {
    ownerName: "Dal Hyndman",
    recordType: "Property",
    taxYear: 2020,
    account: 1442850,
    paid: true,
    amount: 171.47,
  },
  {
    ownerName: "Amelia Cristofolini",
    recordType: "Property",
    taxYear: 2020,
    account: 1766328,
    paid: false,
    amount: 52.6,
  },
  {
    ownerName: "Dudley Dorant",
    recordType: "Property",
    taxYear: 2020,
    account: 1470252,
    paid: true,
    amount: 395.39,
  },
  {
    ownerName: "Rhoda McConville",
    recordType: "Property",
    taxYear: 2020,
    account: 1325336,
    paid: false,
    amount: 281.43,
  },
  {
    ownerName: "Dyan McCullock",
    recordType: "Property",
    taxYear: 2020,
    account: 1294258,
    paid: true,
    amount: 436.28,
  },
  {
    ownerName: "Artur Shelliday",
    recordType: "Property",
    taxYear: 2020,
    account: 1301924,
    paid: false,
    amount: 52.31,
  },
  {
    ownerName: "Bibbie Abraham",
    recordType: "Property",
    taxYear: 2020,
    account: 1935840,
    paid: true,
    amount: 270.95,
  },
  {
    ownerName: "Rosalia Dionisetti",
    recordType: "Property",
    taxYear: 2020,
    account: 1719371,
    paid: false,
    amount: 83.14,
  },
  {
    ownerName: "Lara Grigore",
    recordType: "Property",
    taxYear: 2020,
    account: 1283894,
    paid: true,
    amount: 125.35,
  },
  {
    ownerName: "Conni Spyvye",
    recordType: "Property",
    taxYear: 2020,
    account: 1385937,
    paid: false,
    amount: 484.68,
  },
  {
    ownerName: "Powell Hallaways",
    recordType: "Property",
    taxYear: 2020,
    account: 1656499,
    paid: false,
    amount: 430.61,
  },
  {
    ownerName: "Sheri Beddows",
    recordType: "Property",
    taxYear: 2020,
    account: 1923206,
    paid: false,
    amount: 21.5,
  },
  {
    ownerName: "Merola Adshede",
    recordType: "Property",
    taxYear: 2020,
    account: 1772659,
    paid: true,
    amount: 235.03,
  },
  {
    ownerName: "Kelby Caiger",
    recordType: "Property",
    taxYear: 2020,
    account: 1369301,
    paid: false,
    amount: 158.18,
  },
  {
    ownerName: "Biddy Strasse",
    recordType: "Property",
    taxYear: 2020,
    account: 1901553,
    paid: true,
    amount: 215.21,
  },
  {
    ownerName: "Jorgan Revington",
    recordType: "Property",
    taxYear: 2020,
    account: 1706355,
    paid: false,
    amount: 198.76,
  },
  {
    ownerName: "Conroy Mustoe",
    recordType: "Property",
    taxYear: 2020,
    account: 1845785,
    paid: true,
    amount: 106.26,
  },
  {
    ownerName: "Brooks Sevitt",
    recordType: "Property",
    taxYear: 2020,
    account: 1817323,
    paid: false,
    amount: 192.82,
  },
  {
    ownerName: "Courtnay Foston",
    recordType: "Property",
    taxYear: 2020,
    account: 1489135,
    paid: false,
    amount: 485.1,
  },
  {
    ownerName: "Gerrilee Sandels",
    recordType: "Property",
    taxYear: 2020,
    account: 1797253,
    paid: true,
    amount: 345.56,
  },
  {
    ownerName: "Cesya Hrycek",
    recordType: "Property",
    taxYear: 2020,
    account: 1716415,
    paid: false,
    amount: 65.04,
  },
  {
    ownerName: "Alana Karlicek",
    recordType: "Property",
    taxYear: 2020,
    account: 1304042,
    paid: true,
    amount: 209.77,
  },
  {
    ownerName: "Philippine Mordan",
    recordType: "Property",
    taxYear: 2020,
    account: 1813167,
    paid: true,
    amount: 208.63,
  },
  {
    ownerName: "Isis Lottrington",
    recordType: "Property",
    taxYear: 2020,
    account: 1635519,
    paid: true,
    amount: 376.46,
  },
  {
    ownerName: "Sarette Dmitriev",
    recordType: "Property",
    taxYear: 2020,
    account: 1961381,
    paid: false,
    amount: 374.93,
  },
  {
    ownerName: "Sherilyn Andric",
    recordType: "Property",
    taxYear: 2020,
    account: 1571365,
    paid: true,
    amount: 444.11,
  },
  {
    ownerName: "Wendeline Stokell",
    recordType: "Property",
    taxYear: 2020,
    account: 1324672,
    paid: true,
    amount: 332.55,
  },
  {
    ownerName: "Carling Ovett",
    recordType: "Property",
    taxYear: 2020,
    account: 1883203,
    paid: true,
    amount: 77.62,
  },
  {
    ownerName: "Bing Lombardo",
    recordType: "Property",
    taxYear: 2020,
    account: 1670803,
    paid: false,
    amount: 393.48,
  },
  {
    ownerName: "Joelie Freyn",
    recordType: "Property",
    taxYear: 2020,
    account: 1420771,
    paid: true,
    amount: 124.15,
  },
  {
    ownerName: "Bjorn Sanbrooke",
    recordType: "Property",
    taxYear: 2020,
    account: 1735170,
    paid: false,
    amount: 375.93,
  },
  {
    ownerName: "Ham Lewens",
    recordType: "Property",
    taxYear: 2020,
    account: 1775504,
    paid: true,
    amount: 298.82,
  },
  {
    ownerName: "Maurits Slixby",
    recordType: "Property",
    taxYear: 2020,
    account: 1315711,
    paid: true,
    amount: 144.64,
  },
  {
    ownerName: "Jerrie Halley",
    recordType: "Property",
    taxYear: 2020,
    account: 1844084,
    paid: true,
    amount: 169.47,
  },
  {
    ownerName: "Dareen Coal",
    recordType: "Property",
    taxYear: 2020,
    account: 1616547,
    paid: true,
    amount: 165.39,
  },
  {
    ownerName: "Clerkclaude Hatchman",
    recordType: "Property",
    taxYear: 2020,
    account: 1966243,
    paid: true,
    amount: 302.2,
  },
  {
    ownerName: "Sloan Breed",
    recordType: "Property",
    taxYear: 2020,
    account: 1694229,
    paid: false,
    amount: 288.72,
  },
  {
    ownerName: "Ginelle Huff",
    recordType: "Property",
    taxYear: 2020,
    account: 1858699,
    paid: true,
    amount: 167.68,
  },
  {
    ownerName: "Waylon Braidon",
    recordType: "Property",
    taxYear: 2020,
    account: 1514730,
    paid: false,
    amount: 486.33,
  },
  {
    ownerName: "Federica Hincham",
    recordType: "Property",
    taxYear: 2020,
    account: 1390174,
    paid: false,
    amount: 475.88,
  },
  {
    ownerName: "Karel Conlaund",
    recordType: "Property",
    taxYear: 2020,
    account: 1921994,
    paid: false,
    amount: 404.45,
  },
  {
    ownerName: "Ketty Messruther",
    recordType: "Property",
    taxYear: 2020,
    account: 1305213,
    paid: false,
    amount: 40.94,
  },
  {
    ownerName: "Rollins Dimitriou",
    recordType: "Property",
    taxYear: 2020,
    account: 1834114,
    paid: false,
    amount: 117.76,
  },
  {
    ownerName: "Lorry Soda",
    recordType: "Property",
    taxYear: 2020,
    account: 1537514,
    paid: true,
    amount: 83.47,
  },
  {
    ownerName: "Leila Friedenbach",
    recordType: "Property",
    taxYear: 2020,
    account: 1687608,
    paid: false,
    amount: 193.28,
  },
  {
    ownerName: "Emlyn Byrkmyr",
    recordType: "Property",
    taxYear: 2020,
    account: 1467582,
    paid: false,
    amount: 319.39,
  },
  {
    ownerName: "Laurens Thompson",
    recordType: "Property",
    taxYear: 2020,
    account: 1718631,
    paid: true,
    amount: 235.22,
  },
  {
    ownerName: "Brynna Siddaley",
    recordType: "Property",
    taxYear: 2020,
    account: 1574536,
    paid: true,
    amount: 492.17,
  },
  {
    ownerName: "Dew Sisson",
    recordType: "Property",
    taxYear: 2020,
    account: 1239691,
    paid: true,
    amount: 391.3,
  },
  {
    ownerName: "Georgie Chessill",
    recordType: "Property",
    taxYear: 2020,
    account: 1383651,
    paid: true,
    amount: 440.78,
  },
];
